<template>
    <v-card v-if="load_tab">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-tabs background-color="#4b89ac" slider-color="#C89933" optional :icons-and-text="true" centered
            active-class="active">
            <v-tab class="normalize font-weight-bold" @click="tab = 'basic'">
                Basic Info
                <v-icon>mdi-heart</v-icon>
            </v-tab>

            <v-tab class="normalize font-weight-bold" @click="tab = 'address'">
                Address
                <v-icon>mdi-account-box</v-icon>
            </v-tab>

            <v-tab class="normalize font-weight-bold" @click="tab = 'contact'">
                Contact
                <v-icon>mdi-phone</v-icon>
            </v-tab>

            <v-tab class="normalize font-weight-bold" @click="tab = 'relative'">
                Relatives
                <v-icon>mdi-account-box</v-icon>
            </v-tab>

            <v-tab class="normalize font-weight-bold" @click="tab = 'castinfo'">
                Caste Information
                <v-icon>mdi-account-box</v-icon>
            </v-tab>
            <v-tab class="normalize font-weight-bold" @click="tab = 'photoinfo'">
                Photo
                <v-icon>mdi-account-box</v-icon>
            </v-tab>
            <v-tab class="normalize font-weight-bold" @click="tab = 'otherinfo'">
                Other
                <v-icon>mdi-account-box</v-icon>
            </v-tab>
            <v-tab class="normalize font-weight-bold" @click="tab = 'documents'">
                Documents
                <v-icon>mdi-file-search</v-icon>
            </v-tab>
            <v-tab class="normalize font-weight-bold" @click="tab = 'history'">
                Payment History
                <v-icon>mdi-history</v-icon>
            </v-tab>
            <v-tab class="normalize font-weight-bold" @click="tab = 'health'">
                Health Check-up Report
                <v-icon>mdi-cards</v-icon>
            </v-tab>
            <v-tab class="normalize font-weight-bold" @click="tab = 'awards'">
                Awards/Recognition
                <v-icon>mdi-cards</v-icon>
            </v-tab>
        </v-tabs>
        <v-col cols="12" sm="12" md="12">
            <v-form id="student_data">
                <!-- basic -->
                <v-card-text v-if="tab == 'basic'" class="box">
                    <br />
                    <v-row justify="center" align="center">
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.registration_number" name="registration_number"
                                label="Registration Number" disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.srn"
                                name="srn" label="SRN" :readonly="critical_edit"></v-text-field>
                        </v-col>
                        <v-col cols=" 12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.pen_no"
                                :rules="[v => (v && v.toString().length === 11) || 'PEN must be exactly 11 digits']"
                                name="pen_no" label="PEN (permanant education number)"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.saral_id"
                                name="saral_id" label="Saral Id"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.standard"
                                name="standard" label="Standard" disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.division"
                                name="division" label="Division" disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.roll_no"
                                name="roll_no" label="Roll No." disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.gr_no"
                                name="gr_no" label="GR Number" :disabled="disabled_gr_number"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <!-- {{stud_data}} -->
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.stud_firstname"
                                name="stud_firstname" label="Student's First name"
                                :readonly="critical_edit"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_middlename" name="stud_middlename" label="Student's Middle name"
                                :readonly="critical_edit"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.stud_lastname"
                                name="stud_lastname" label="Student's Last name"
                                :readonly="critical_edit"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.student_name_as_per_doc"
                                name="student_name_as_per_doc" label="Student Name As Per Document"
                                :readonly="critical_edit"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.name_as_aadhar_card" name="name_as_aadhar_card"
                                label="Name as per aadhar card" :readonly="critical_edit"></v-text-field>
                        </v-col>
                        <v-col v-if="tenant == 'sbpps' || tenant == 'eps'" cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.parent_name"
                                name="parent_name" label="Parent Name"></v-text-field>
                        </v-col>
                        <v-col v-if="tenant == 'sbpps' || tenant == 'eps'" cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                                v-model.trim="stud_data.parent_contact_no" name="parent_contact_no"
                                label="Parent Contact No."></v-text-field>
                        </v-col>
                        <v-col v-if="tenant == 'sbpps' || tenant == 'eps'" cols="12" sm="4" md="4" class="pt-0 pb-0">
                            Is Single Parent? <v-switch v-model="stud_data.issingleparent"
                                :color="stud_data.issingleparent ? 'success' : 'primary'"></v-switch>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <!-- {{stud_data.languages_known}} -->
                            <!-- <v-autocomplete rounded outlined color="#0F2027" single-line flat dense v-model="stud_data.languages_known" multiple :items="language_list" name="languages_known" label="Languages Spoken At Home"></v-autocomplete> -->
                            <v-autocomplete dense v-model="stud_data.languages_known" :items="language_list" single-line
                                multiple :clearable="true" hint="Languages Spoken At Home" persistent-hint
                                outlined></v-autocomplete>

                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.apaar_id"
                                type="number"
                                :rules="[v => (v && v.toString().length === 12) || 'APAAR ID must be exactly 12 digits']"
                                name="apaar_id" label="APAAR ID"></v-text-field>
                        </v-col>
                        <!-- add check box for full name shiv-->

                        <v-col cols="12" sm="12" md="12" class="pt-0 pb-0">
                            <v-checkbox v-model="StudFullName" color="#0F2027"
                                :label="`Copy Full Name as ${stud_data.stud_firstname} ${stud_data.stud_middlename} ${stud_data.stud_lastname}`"
                                @change="copyFullName()"></v-checkbox>
                        </v-col>

                        <!-- add check box for full name shiv-->

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field
                            rounded outlined dense
                            v-model.trim="stud_data.stud_fullname" name="stud_fullname"
                            @input="convertToUnicode(stud_data.stud_fullname, 'unicode_student_name')"
                            label="Student's Full Name">
                            </v-text-field>
                        </v-col>
                    

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined dense
                                v-model.trim="stud_data.stud_father_full_name" name="stud_father_full_name"
                                @input="convertToUnicode(stud_data.stud_father_full_name, 'unicode_father_name')"
                                label="Father's First name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined dense
                                v-model.trim="stud_data.stud_mother_first_name" name="stud_mother_first_name"
                                @input="convertToUnicode(stud_data.stud_mother_first_name, 'unicode_mother_name')"
                                label="Mother's First name"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0" v-if="stud_data.unicode_fields_in_edit_student && stud_data.unicode_fields_in_edit_student.required">
                            <v-text-field
                                v-if="stud_data.unicode_fields_in_edit_student && stud_data.unicode_fields_in_edit_student.required"
                                rounded outlined dense name="unicode_student_name"
                                v-model.trim="stud_data.unicode_student_name"
                                label="Unicode Student Full Name">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0" v-if="stud_data.unicode_fields_in_edit_student && stud_data.unicode_fields_in_edit_student.required">
                            <v-text-field rounded outlined dense v-model.trim="stud_data.unicode_father_name"
                                name="unicode_father_name" label="Unicode Father Name"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0" v-if="stud_data.unicode_fields_in_edit_student && stud_data.unicode_fields_in_edit_student.required">
                            <v-text-field rounded outlined dense v-model.trim="stud_data.unicode_mother_name"
                                name="unicode_mother_name" label="Unicode Mother Name"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <!-- <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.stud_gender" name="stud_gender" label="Gender"></v-text-field> -->
                            <v-autocomplete rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.stud_gender"
                                :items="stud_data.gender_list" name="stud_gender" label="Gender"></v-autocomplete>
                        </v-col>
                        <v-col v-if="formatted_dob" cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field outlined dense @blur="updateDate" type="date" v-model.trim="formattedDate"
                                label="Date Of Birth" name="stud_date_of_birth" hint="Date Of Birth"
                                rounded></v-text-field>
                        </v-col>
                        <v-col v-else cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field dense rounded outlined
                                        @blur="date = parseDate(stud_data.stud_date_of_birth)" hint="YYYY/MM/DD format"
                                        persistent-hint v-model.trim="stud_data.stud_date_of_birth" label="Date Of Birth"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker style="height:400px" v-model="stud_data.stud_date_of_birth"
                                    @input="menu3 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined dense
                               v-model.trim="stud_data.stud_birth_place" name="stud_birth_place"
                               @input="convertToUnicode(stud_data.stud_birth_place, 'unicode_birth_place')"
                                label="Birth Place"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0" v-if="stud_data.unicode_fields_in_edit_student && stud_data.unicode_fields_in_edit_student.required">
                            <v-text-field rounded outlined dense v-model.trim="stud_data.unicode_birth_place"
                                name="unicode_birth_place" label="Unicode Birth Place"></v-text-field>
                        </v-col>


                        <v-col cols="12" sm="6" md="6" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_date_of_birth_in_words" name="stud_date_of_birth_in_words"
                                label="Date of Birth in Words"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_birth_address" name="stud_birth_address"
                                label="Birth Address"></v-text-field>
                        </v-col>

                        <v-autocomplete dense rounded outlined name="stud_bloodgroup" class="ml-5 mr-5 pt-1"
                            v-model="stud_data.stud_bloodgroup[0]" :items="stud_data.stud_bloodgroup_list"
                            item-text="name" return-object label="Select Blood Group" persistent-hint></v-autocomplete>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.stud_aadhar_no"
                                type="number"
                                :rules="[v => (v && v.toString().length === 12) || 'Aadhar No. must be exactly 12 digits']"
                                name="stud_aadhar_no" label="Aadhar No"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0" v-if="tenant!='sbpps'">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.mother_name_as_per_doc" name="mother_name_as_per_doc"
                                label="Mother Name as per Document"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0" v-if="tenant!='sbpps'">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.father_name_as_per_doc" name="father_name_as_per_doc"
                                label="Father Name as per Document"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense
                                v-model="stud_data.stud_mothertoungue" :items="stud_data.language_list"
                                name="stud_mothertoungue" label="MotherTongue"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense
                                v-model="stud_data.stud_birthcountry" :items="stud_data.birthcountry_list"
                                name="stud_birthcountry" label="BirthCountry"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.birth_district"
                                name="birth_district" label="Birth District"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined dense v-model.trim="stud_data.birth_taluka"
                            @input="convertToUnicode(stud_data.birth_taluka, 'unicode_birth_taluka')"
                                name="birth_taluka" label="Birth Taluka"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0" v-if="stud_data.unicode_fields_in_edit_student && stud_data.unicode_fields_in_edit_student.required">
                            <v-text-field rounded outlined dense v-model.trim="stud_data.unicode_birth_taluka"
                                name="unicode_birth_taluka" label="Unicode Birth Taluka"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.birth_state"
                                name="birth_state" label="Birth State"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                                v-model.trim="stud_data.family_income" name="family_income"
                                label="Family Income"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense v-model="stud_data.familytype"
                                :items="family_type_list" name="family_type" label="Family Type"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.citizenship"
                                name="citizenship" label="Citizenship"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense v-model="stud_data.nationality"
                                :items="stud_data.country_list" name="nationality" label="Nationality"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.identification_mark_on_body" name="identification_mark_on_body"
                                label="Visible Identification Mark On Body."></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.allergy"
                                name="allergy" label="Any Allergy."></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.medical_condition" name="medical_condition"
                                label="Any Medical Condition."></v-text-field>
                        </v-col>
                         <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.hemoglobin" name="hemoglobin_level" label="Hemoglobin Level"
                                type="number" inputmode="numeric"
                                @input="stud_data.hemoglobin = String(stud_data.hemoglobin).replace(/\D/g, '').slice(0, 2)"
                               ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-checkbox color="#0F2027" v-model="stud_data.isvaccination"
                                label="Is Vaccination Done ?"></v-checkbox>
                        </v-col>

                        <!-- <template v-if="tenant == 'eps'">
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.guardian1_name"
                                    name="guardian1_name" label="Guardian 1"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.guardian2_name"
                                    name="guardian2_name" label="Guardian 2"></v-text-field>
                            </v-col>
                        </template> -->
                        <v-col>
                            <input type="hidden" :value="basicData" name="basicData" />
                        </v-col>
                    </v-row>
                    <div class="text-center">
                        <v-btn class="button" :loading="save_loader" @click="saveBasic">Save</v-btn>
                    </div>
                    <!-- <v-btn @click="saveBasic">Save</v-btn> -->
                </v-card-text>
                <!-- contact -->
                <v-card-text v-if="tab == 'contact'" class="box">
                    <v-col cols="12" sm="12" md="12">
                        <v-row>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Contact Details </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </v-row>
                    </v-col>
                    <v-row class="pt-5">
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027"
                                hint="Primary contact no. use for communication" flat dense type="number"
                                v-model.trim="stud_data.contact_number" name="contact_number"
                                label="Primary Contact Number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                                v-model.trim="stud_data.father_contact_number" name="stud_father_contact_number"
                                label="Father Contact Number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" hint="Primary email use for communication"
                                flat dense v-model.trim="stud_data.personal_email" name="personal_email"
                                label="Primary Email"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_father_email" name="stud_father_email"
                                label="Father Email"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                                v-model.trim="stud_data.mother_contact_number" name="stud_mother_contact_number"
                                label="Mother Contact Number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_mother_email" name="stud_mother_email"
                                label="Mother Email"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.parent_primary_no" name="parent_primary_no"
                                label="Parent Primary Contact Number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.parent_primary_email" name="parent_primary_email"
                                label="Parent Primary Email"></v-text-field>
                        </v-col>
                           <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                                v-model.trim="stud_data.student_contact_number" name="student_contact_number"
                                label="Student Contact Number"></v-text-field>
                        </v-col>
                         <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.student_email" name="student_email"
                                label="Student Email"></v-text-field>
                        </v-col>

                        <!-- <v-col>
                        <input type="hidden" :value="stud_data.registration_number" name="registration_number" />
                    </v-col> -->
                        <!-- <v-col>
                        <input type="hidden" :value="contactData" name="contactData" />
                    </v-col> -->
                    </v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-row>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Emergency Contact Details </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </v-row>
                    </v-col>
                    <v-row class="pt-5">
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_emergency_contact_name" name="stud_emergency_contact_name"
                                label="Emergency Contact Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                                v-model.trim="stud_data.stud_emergency_contact_number" name="stud_emergency_contact_number"
                                label="Emergency Contact Number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_emergency_contact_address" name="stud_emergency_contact_address"
                                label="Emergency Contact Address"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_emergency_relation" name="stud_emergency_relation"
                                label="Relation With Child"></v-text-field>
                        </v-col>
                           
                        
                        
                    </v-row>
                    <template v-if="tenant == 'sbpps' || tenant == 'eps'">
                        <v-col cols="12" sm="12" md="12">
                            <v-row>
                                <v-toolbar class="toolbar" flat dense>
                                    <v-toolbar-title>
                                        <strong> Guardian Contact Details </strong>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </v-row>
                        </v-col>
                        <v-row class="pt-5">
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <v-text-field rounded outlined color="#0F2027" flat dense
                                    v-model.trim="stud_data.guardian1_name" name="guardian1_name"
                                    label="Guardian 1 Name"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                                    v-model.trim="stud_data.guardian1_contact" name="guardian1_contact"
                                    label="Guardian 1 Contact"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <v-text-field rounded outlined color="#0F2027" flat dense
                                    v-model.trim="stud_data.guardian2_name" name="guardian2_name"
                                    label="Guardian 2 Name"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                                    v-model.trim="stud_data.guardian2_contact" name="guardian2_contact"
                                    label="Guardian 2 Contact"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="pt-5">
                            <v-col cols="12" sm="5" md="5" class="pt-0 pb-0">
                                <v-textarea rounded outlined color="#0F2027" flat dense
                                    v-model.trim="stud_data.guardian_address" name="guardian_address"
                                    label="Guardian1 Address"></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <v-text-field rounded outlined color="#0F2027" flat dense
                                    v-model.trim="stud_data.guardian_email" name="guardian_email"
                                    label="Guardian1 Email"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                                <v-text-field rounded outlined color="#0F2027" flat dense
                                    v-model.trim="stud_data.guardian_relation" name="guardian_relation"
                                    label="Guardian1 Relation With Child"></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <v-col>
                        <input type="hidden" :value="contactData" name="contactData" />
                    </v-col>
                    <div class="text-center">
                        <v-btn class="button" :loading="save_loader" @click="saveContact">Save</v-btn>
                    </div>
                    <!-- <v-btn @click="saveContact">Save</v-btn> -->
                </v-card-text>
                <!-- address -->
                <v-card-text v-if="tab == 'address'" class="box">
                    <v-col cols="12" sm="12" md="12">
                        <v-row>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Address Details </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </v-row>
                    </v-col>

                    <v-row dense justify="center">
                        <v-col cols="10" sm="10" md="10">
                            <v-textarea dense :value="stud_data.laddress" v-model="stud_data.laddress" name="laddress"
                                hint="Address" persistent-hint
                                :prepend-icon="stud_data.laddress != null ? 'mdi-home' : 'mdi-home-outline'"
                                outlined @input="convertToUnicode(stud_data.laddress, 'unicode_laddress')"></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row dense justify="center">
                        <v-col cols="10" sm="10" md="10">
                            <v-textarea dense :value="stud_data.unicode_laddress" v-model="stud_data.unicode_laddress" name="unicode_laddress"
                                hint="Unicode Address" persistent-hint
                                :prepend-icon="stud_data.unicode_laddress != null ? 'mdi-home' : 'mdi-home-outline'"
                                outlined></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row dense justify="center">
                        <v-col cols="5" sm="5" md="5">
                            <v-autocomplete dense v-model="stud_data.lcountry" :items="country_list" name="lcountry"
                                return-object single-line :prepend-icon="stud_data.lcountry != null
                                    ? 'mdi-flag'
                                    : 'mdi-flag-variant-outline'
                                    " outlined hint="Country" persistent-hint
                                @change="getStates(stud_data.lcountry)"></v-autocomplete>
                        </v-col>
                        <v-col cols="10" sm="5" md="5">
                            <v-autocomplete dense v-model="stud_data.lstate" :items="state_list" name="lstate"
                                return-object single-line :prepend-icon="stud_data.lstate != null
                                    ? 'mdi-alpha-o-circle'
                                    : 'mdi-alpha-o-circle-outline'
                                    " outlined hint="State" persistent-hint
                                @change="getCitiesLocal(stud_data.lstate)"></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row dense justify="center">
                        <v-col cols="10" sm="5" md="5">
                            <v-autocomplete dense v-model="stud_data.lcity" :items="cities_list" name="lcity"
                                return-object single-line :prepend-icon="stud_data.lcity != null
                                    ? 'mdi-alpha-o-circle'
                                    : 'mdi-alpha-o-circle-outline'
                                    " outlined hint="City" persistent-hint></v-autocomplete>
                        </v-col>
                        <v-col cols="10" sm="5" md="5">
                            <v-autocomplete dense v-model="stud_data.ldistrict" :items="district_list" name="ldistrict"
                                :clearable="stud_data.ldistrict ? false : true" return-object single-line :prepend-icon="stud_data.ldistrict != null
                                    ? 'mdi-alpha-o-circle'
                                    : 'mdi-alpha-o-circle-outline'
                                    " outlined hint="District" persistent-hint></v-autocomplete>
                        </v-col>
                        <v-col cols="5" sm="5" md="5">
                            <v-text-field dense v-model.trim="stud_data.ltaluka" name="ltaluka" return-object single-line
                                :prepend-icon="stud_data.ltaluka != null
                                    ? 'mdi-map-marker'
                                    : 'mdi-map-marker-outline'
                                    " outlined hint="Taluka" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="5" sm="5" md="5">
                            <v-text-field dense v-model.trim="stud_data.lpin" name="lpin" type="number" return-object
                                single-line :prepend-icon="stud_data.lpin != null
                                    ? 'mdi-map-marker'
                                    : 'mdi-map-marker-outline'
                                    " outlined hint="Pincode" persistent-hint></v-text-field>
                        </v-col>
                    </v-row>

                    <hr color="grey lighten-1" />
                    <v-row dense justify="center">
                        <v-col cols="12" sm="10" md="10">
                            <v-checkbox v-model="pladdress" color="#0F2027"
                                :label="`Whether Permanent Address is same as ${stud_data.laddress}`"
                                @change="copyAddress()"></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-row dense justify="center">
                        <v-col cols="10" sm="10" md="10">
                            <v-textarea dense :value="stud_data.paddress" v-model="stud_data.paddress" name="paddress"
                                hint="Address" persistent-hint :prepend-icon="stud_data.paddress != null
                                    ? 'mdi-home'
                                    : 'mdi-home-outline'
                                    " outlined
                                    @input="convertToUnicode(stud_data.paddress, 'unicode_paddress')">
                                    </v-textarea>
                        </v-col>
                    </v-row>
                     <v-row dense justify="center">
                        <v-col cols="10" sm="10" md="10">
                            <v-textarea dense :value="stud_data.unicode_paddress" v-model="stud_data.unicode_paddress" name="unicode_paddress"
                                hint="Unicode Address" persistent-hint
                                :prepend-icon="stud_data.unicode_paddress != null ? 'mdi-home' : 'mdi-home-outline'"
                                outlined ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row dense justify="center">
                        <v-col cols="5" sm="5" md="5">
                            <v-autocomplete dense v-model="stud_data.pcountry" :items="country_list" name="pcountry"
                                return-object single-line :prepend-icon="stud_data.pcountry != null
                                    ? 'mdi-flag'
                                    : 'mdi-flag-variant-outline'
                                    " outlined hint="Country" persistent-hint
                                @change="getStates(stud_data.pcountry)"></v-autocomplete>
                        </v-col>
                        <v-col cols="10" sm="5" md="5">
                            <v-autocomplete dense v-model="stud_data.pstate" :items="state_list" name="pstate"
                                return-object single-line :prepend-icon="stud_data.pstate != null
                                    ? 'mdi-alpha-o-circle'
                                    : 'mdi-alpha-o-circle-outline'
                                    " outlined hint="State" persistent-hint
                                @change="getCitiesPermanant(stud_data.pstate)"></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row dense justify="center">
                        <v-col cols="10" sm="5" md="5">
                            <v-autocomplete dense v-model="stud_data.pcity" :items="cities_list_permanant" name="pcity"
                                :clearable="stud_data.pcity ? false : true" return-object single-line :prepend-icon="stud_data.pcity != null
                                    ? 'mdi-alpha-o-circle'
                                    : 'mdi-alpha-o-circle-outline'
                                    " outlined hint="City" persistent-hint></v-autocomplete>
                        </v-col>
                        <v-col cols="10" sm="5" md="5">
                            <v-autocomplete dense v-model="stud_data.pdistrict" :items="district_list" name="pdistrict"
                                :clearable="stud_data.pdistrict ? false : true" return-object single-line :prepend-icon="stud_data.pdistrict != null
                                    ? 'mdi-alpha-o-circle'
                                    : 'mdi-alpha-o-circle-outline'
                                    " outlined hint="District" persistent-hint></v-autocomplete>
                        </v-col>
                        <v-col cols="5" sm="5" md="5">
                            <v-text-field dense v-model.trim="stud_data.ptaluka" name="ptaluka" return-object single-line
                                :prepend-icon="stud_data.ptaluka != null
                                    ? 'mdi-map-marker'
                                    : 'mdi-map-marker-outline'
                                    " outlined hint="Taluka" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="5" sm="5" md="5">
                            <v-text-field dense v-model.trim="stud_data.ppin" name="ppin" type="number" return-object
                                single-line :prepend-icon="stud_data.ppin != null
                                    ? 'mdi-map-marker'
                                    : 'mdi-map-marker-outline'
                                    " outlined hint="Pincode" persistent-hint></v-text-field>
                        </v-col>
                    </v-row>
                    <v-col>
                        <input type="hidden" :value="addressData" name="addressData" />
                    </v-col>
                    <div class="text-center">
                        <v-btn class="button" @click="saveAddress">Save</v-btn>
                    </div>
                    <!-- <v-btn @click="saveContact">Save</v-btn> -->
                </v-card-text>
                <!-- relative -->
                <v-card-text v-if="tab == 'relative'" class="box">
                    <v-row v-if="stud_data.mother == true">
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                            <v-alert elevation="2" class="pt-1 pb-1 toolbar">Mother's Information</v-alert>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.mother_fullname" name="mother_full_name"
                                label="Mother Full Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.mother_education" name="mother_education"
                                label="Mother Education"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                               v-model.trim="stud_data.mother_income" name="mother_income"
                                label="Mother Annual Income"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.mother_email"
                                name="mother_email" label="Mother Email"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.mother_organization_name" name="mother_organization_name"
                                label="Mother Organization Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                               v-model.trim="stud_data.mother_department" name="mother_department"
                                label="Mother Department"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.mother_designation" name="mother_designation"
                                label="Mother Designation"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.mother_office_address" name="mother_office_address"
                                label="Mother Office Address"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                                v-model.trim="stud_data.mother_contact_no" name="mother_contact_no"
                                label="Mother Contact Number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.mother_occupation" name="mother_occupation"
                                label="Mother Occupation"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.mother_aadharno" name="mother_aadharno"
                                label="Mother Aadhar No"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field outlined dense type="date" v-model.trim="stud_data.mother_dob"
                                label="Date Of Birth" name="mother_dob" hint="Date Of Birth" rounded></v-text-field>
                            <!-- <input rounded outlined color="#0F2027" type="date" v-model="stud_data.mother_dob" /> -->
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0" v-if="tenant=='sbpps'">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.mother_name_as_per_doc" name="mother_name_as_per_doc"
                                label="Mother Name as per Document"></v-text-field>
                        </v-col>
                        <v-col>
                            <input type="hidden" :value="stud_data.mother" name="mother" />
                        </v-col>
                        
                    </v-row>
                    <v-row v-if="stud_data.father == true">
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                            <v-alert elevation="2" class="pt-1 pb-1 toolbar">Father's Information</v-alert>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.father_fullname" name="father_full_name"
                                label="Father Full Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.father_education" name="father_education"
                                label="Father Education"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                                v-model.trim="stud_data.father_income" name="father_income"
                                label="Father Annual Income"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.father_email"
                                name="father_email" label="Father Email"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.father_organization_name" name="father_organization_name"
                                label="Father Organization Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.father_department" name="father_department"
                                label="Father Department"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.father_designation" name="father_designation"
                                label="Father Designation"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.father_office_address" name="father_office_address"
                                label="Father Office Address"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                               v-model.trim="stud_data.father_contact_no" name="father_contact_no"
                                label="Father Contact Number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                               v-model.trim="stud_data.father_occupation" name="father_occupation"
                                label="Father Occupation"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.father_aadharno" name="father_aadharno"
                                label="Father Aadhaar No"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field outlined dense type="date" v-model.trim="stud_data.father_dob" name="father_dob"
                                label="Date Of Birth" hint="Date Of Birth" rounded></v-text-field>
                            <!-- <input rounded outlined color="#0F2027" type="date" v-model="stud_data.mother_dob" /> -->
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0" v-if="tenant=='sbpps'">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.father_name_as_per_doc" name="father_name_as_per_doc"
                                label="Father Name as per Document"></v-text-field>
                        </v-col>
                        <v-col>
                            <input type="hidden" :value="stud_data.father" name="father" />
                        </v-col>
                        

                    </v-row>

                    <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                        <v-alert elevation="2" class="pt-1 pb-1 toolbar">Sibling Details</v-alert>
                    </v-col>
                    <v-col cols="12">
                        <v-row v-if="sibling1 != null">
                            <input type="hidden" name="sib1_id" :value="sibling1.sib_id" />
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field prepend-icon="mdi-numeric-1-circle-outline" dense
                                    v-model.trim="sibling1.sibling_name" name="sib1_name" outlined hint="Name"
                                    persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field dense v-model.trim="sibling1.name_of_school" name="sib1_school_name"
                                    outlined hint="School Name" persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" v-if="tenant == 'uwws'">
                                <v-text-field dense type="number" v-model.trim="sibling1.age" name="sib1_age" outlined
                                    hint="Age" persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" v-if="tenant != 'uwws'">
                                <v-text-field dense v-model.trim="sibling1.date_of_birth" type="date" name="sib1_dob"
                                    outlined hint="DOB DD/MM/YYYY" persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" v-if="tenant != 'uwws'">
                                <v-autocomplete dense v-model="sibling1.relationtype" :items="relationtype_list"
                                    name="sib1_relation" single-line outlined hint="Relationship with the child"
                                    persistent-hint></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" v-if="tenant != 'uwws'">
                                <v-autocomplete dense v-model="sibling1.standard" :items="standard_list"
                                    name="sib1_standard" single-line outlined hint="Grade"
                                    persistent-hint></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="sibling2 != null">
                            <input type="hidden" name="sib2_id" :value="sibling2.sib_id" />
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field dense v-model.trim="sibling2.sibling_name" name="sib2_name" outlined
                                    hint="Name" prepend-icon="mdi-numeric-2-circle-outline"
                                    persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field dense v-model.trim="sibling2.name_of_school" name="sib2_school_name"
                                    outlined hint="School Name" persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" v-if="tenant == 'uwws'">
                                <v-text-field dense type="number" v-model.trim="sibling2.age" name="sib2_age" outlined
                                    hint="Age" persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" v-if="tenant != 'uwws'">
                                <v-text-field dense v-model.trim="sibling2.date_of_birth" type="date" name="sib1_dob"
                                    outlined hint="DOB DD/MM/YYYY" persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" v-if="tenant != 'uwws'">
                                <v-autocomplete dense v-model="sibling2.relationtype" :items="relationtype_list"
                                    name="sib2_relation" single-line outlined hint="Relationship with the child"
                                    persistent-hint></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" v-if="tenant != 'uwws'">
                                <v-autocomplete dense v-model="sibling2.standard" :items="standard_list"
                                    name="sib2_standard" single-line outlined hint="Grade"
                                    persistent-hint></v-autocomplete>
                            </v-col>
                        </v-row>

                    </v-col>


                    <!-- <v-row v-if="stud_data.brother == true">
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                            <v-alert elevation="2" class="pt-1 pb-1 toolbar">Brother's Information</v-alert>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.brother_fullname"
                                name="brother_full_name" label="Brother Full Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.brother_education"
                                name="brother_education" label="Brother Education"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                                v-model="stud_data.brother_income" name="brother_income"
                                label="Brother Income"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.brother_email"
                                name="brother_email" label="Brother Email"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model="stud_data.brother_organization_name" name="brother_organization_name"
                                label="Brother Organization Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.brother_department"
                                name="brother_department" label="Brother Department"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model="stud_data.brother_designation" name="brother_designation"
                                label="Brother Designation"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model="stud_data.brother_office_address" name="brother_office_address"
                                label="Brother Office Address"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                                v-model="stud_data.brother_contact_no" name="brother_contact_no"
                                label="Brother Contact Number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.brother_occupation"
                                name="brother_occupation" label="Brother Occupation"></v-text-field>
                        </v-col>
                        <v-col>
                            <input type="hidden" :value="stud_data.brother" name="brother" />
                        </v-col>
                    </v-row>
                    <v-row v-if="stud_data.sister == true">
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                            <v-alert elevation="2" class="pt-1 pb-1 toolbar">Sister's Information</v-alert>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.sister_fullname"
                                name="sister_full_name" label="Sister Full Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.sister_education"
                                name="sister_education" label="Sister Education"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                                v-model="stud_data.sister_income" name="sister_income" label="Sister Income"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.sister_email"
                                name="sister_email" label="Sister Email"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model="stud_data.sister_organization_name" name="sister_organization_name"
                                label="Sister Organization Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.sister_department"
                                name="sister_department" label="Sister Department"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.sister_designation"
                                name="sister_designation" label="Sister Designation"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model="stud_data.sister_office_address" name="sister_office_address"
                                label="Sister Office Address"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="text"
                                v-model="stud_data.sister_contact_no" name="sister_contact_no"
                                label="Sister Contact Number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.sister_occupation"
                                name="sister_occupation" label="Sister Occupation"></v-text-field>
                        </v-col>
                        <v-col>
                            <input type="hidden" :value="stud_data.sister" name="sister" />
                        </v-col>
                        <v-col>
                            <input type="hidden" :value="relativeData" name="relativeData" />
                        </v-col>
                    </v-row> -->
                    <v-col>
                        <input type="hidden" :value="relativeData" name="relativeData" />
                    </v-col>
                    <div class="text-center">
                        <v-btn class="button" @click="saveRelative">Save</v-btn>
                    </div>
                    <!-- <v-btn @click="saveRelative">Save</v-btn> -->
                </v-card-text>
                <!-- castinfo -->
                <v-card-text v-if="tab == 'castinfo'" class="box">
                    <v-row>
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Caste Information </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </v-col>
                    </v-row>
                    <br />
                    <v-row>
                        <!-- :readonly="org_id == '3' && tenant == 'zeal' ? edit_student_quota_admission_year : false"
                        :filled="org_id == '3' && tenant == 'zeal' ? edit_student_quota_admission_year : false" -->
                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0" v-if="stud_data.quota_edit_flag">
                            <v-autocomplete rounded outlined color="#0F2027" persistent-hint
                                hint="Changing quota will change your fee structure" flat dense
                                :disabled="show_quota == false" v-model="stud_data.quota" :items="stud_data.quota_list"
                                name="quota" label="Quota"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0" v-else>
                            <v-autocomplete disabled rounded outlined color="#0F2027" flat dense
                                v-model="stud_data.quota" :items="stud_data.quota_list" name="quota"
                                :readonly="org_id == '3' && tenant == 'zeal' ? edit_student_quota_admission_year : false"
                                :filled="org_id == '3' && tenant == 'zeal' ? edit_student_quota_admission_year : false"
                                label="Quota"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense v-model="stud_data.religion"
                                :items="stud_data.religion_list" name="religion" label="Religion"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense v-model="stud_data.cast"
                                :items="stud_data.cast_list" name="cast" label="Caste"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense v-model="stud_data.sub_cast"
                                :items="stud_data.sub_cast_list" name="sub_cast" label="Sub Caste"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-file-input dense rounded outlined v-model="cast_cert"
                                placeholder="Upload Caste Certificate" label="Document" prepend-icon="mdi-paperclip"
                                show-size>
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" md="1" v-if="cast_cert">
                            <v-btn class="ma-2" :color="cast_cert ? 'primary darken-1' : 'grey lighten-1'"
                                @click="uploadCasteCertificate()" :disabled="!cast_cert" :loading="upload_image_loader">
                                <v-icon dark> mdi-cloud-upload </v-icon> Upload </v-btn>
                        </v-col>
                        <v-col cols="12" sm="1" md="1" class="pt-0 pb-0" v-if="stud_data.cast_certificate != null">
                            <span> <v-btn text color="primary" icon title="download">
                                    <a :href="aws_path + stud_data.cast_certificate" target="_blank"
                                        style="text-decoration: none;">
                                        <v-icon>mdi-file-download</v-icon>
                                    </a>
                                </v-btn></span>
                            <span>
                                <v-btn text title="Delete File" :loading="delete_load"
                                    @click="deleteAttachment(stud_data)">
                                    <v-icon color="red">mdi-window-close</v-icon>
                                </v-btn></span>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense
                                v-model="stud_data.actual_category" :items="stud_data.category_list"
                                name="actual_category" label="Actual Category"></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense v-model="stud_data.domacile"
                                :items="stud_data.domacile_list" name="domacile" label="Domicile"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-autocomplete rounded outlined color="#0F2027" flat dense v-model="stud_data.category"
                                :items="stud_data.category_list" name="category"
                                label="Admitted Category"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model="stud_data.current_ay_quota"
                                name="Current AY Quota" label="Current Academic Year Quota" disabled></v-text-field>
                        </v-col>
                        <v-col>
                            <input type="hidden" :value="castData" name="castData" />
                        </v-col>
                    </v-row>
                    <div class="text-center">
                        <v-btn class="button" @click="saveCastInfo">Save</v-btn>
                    </div>
                    <!-- <v-btn @click="saveBasic">Save</v-btn> -->
                </v-card-text>
                <!-- photo -->
                <v-card-text v-if="tab == 'photoinfo' && tenant == 'sanjivani'" class="box">
                    <v-row>
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                            <v-alert elevation="2" class="pt-1 pb-1 toolbar">Photo Information</v-alert>
                        </v-col>
                    </v-row>
                    <br />
                    <v-row>
                        <v-row justify="center" dense class="no-display">
                            <v-radio-group v-model="select_photo_type" mandatory row class="radiobtn">
                                <v-radio label="Upload Photo" value="upload" style="font-weight: bold"></v-radio>
                                <v-radio label="Capture Photo" value="capture" style="font-weight: bold"></v-radio>
                            </v-radio-group>
                        </v-row>
                    </v-row>
                    <v-div v-if="select_photo_type == 'upload'">
                        <v-row>
                            <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                                <center v-if="photo_path">
                                    <img :src="aws_path + photo_path" width="200px" height="200px" />
                                    <br />
                                    <v-btn class="mx-2" fab dark small color="primary"
                                        @click="downloadImg(aws_path + photo_path)">
                                        <v-icon>mdi-download</v-icon></v-btn>
                                    <a target="_blank" :href="aws_path + photo_path"
                                        download="myimage"><v-icon>mdi-download</v-icon></a>
                                </center>

                                <v-file-input id="newFile" ref="file" v-model="profile_image" accept="image/*"
                                    @change="handleFileChangeNew()"
                                    hint="Only jpg/jpeg allowed Its better to have photo with dimension of 200x200px"
                                    persistent-hint></v-file-input>
                            </v-col>
                            <!-- <v-col cols="12" sm="4" md="4">
                            {{ image_msg }}
                        </v-col> -->
                        </v-row>
                        <v-row dense justify="center">
                            <p v-if="file">File Height: {{ fileHeight }}, File Width: {{ fileWidth }}</p>
                        </v-row>
                        <v-row dense justify="center">
                            <b style="color:red"> File Should Be In {{ allowed_extensions }} Format And Size Of
                                Uploading
                                Documents Should Be <= {{ imagesize }} MB </b>
                        </v-row>
                        <v-row dense justify="center" v-if="documentheight">
                            <b style="color:red"> image Height Should Be <= {{ documentheight }} And Width Should Be
                                    <={{ documentwidth }} </b>
                        </v-row>

                        <v-row justify="center" dense>
                            <v-btn @click="uploadImage" :disabled="!isvaliddimantions" :loading="upload_image_loader"
                                color="warning" v-if="image_msg == null">Upload Photo</v-btn>
                        </v-row>

                    </v-div>
                    <v-div v-if="select_photo_type == 'capture'">
                        <v-row dense>
                            <v-col cols="12" sm="2" md="2"></v-col>
                            <v-col cols="12" sm="1" md="1">
                                <span style="font-weight: 800">Capture Photo</span>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-btn @click="dialog = true" color="primary" rounded>
                                    <v-icon>mdi-camera</v-icon> Open Camera
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-dialog v-model="dialog" max-width="600px">
                            <v-card>
                                <v-card-title>Capture Photo</v-card-title>
                                <v-card-text>
                                    <div id="camera">
                                        <video ref="video" id="video" width="100%" autoplay />
                                        <canvas ref="canvas" id="canvas" width="300" height="300" />
                                    </div>
                                    
                                    <v-row>
                                        <v-btn rounded color="primary" v-if="photo == null" id="snap"
                                            @click="capture">Capture Photo</v-btn>
                                        <v-img v-if="photo" :src="photo" max-width="200" max-height="200" />
                                        <v-spacer></v-spacer>
                                        
                                       <v-btn icon color="secondary" @click="switchCamera" v-if="hasMultipleCameras">
                                            <v-icon>mdi-camera-flip</v-icon>
                                        </v-btn>
                                    </v-row>
                                    
                                </v-card-text>
                                <!-- <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="green darken-1" text @click="dialog = false">Close</v-btn>
                                </v-card-actions> -->
                            </v-card>
                        </v-dialog>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">
                                <v-img v-if="captured_photo_path != null && captured_photo_name != null"
                                    :src="aws_path + captured_photo_path + captured_photo_name" max-width="200" />
                                <!-- <v-img v-if="captured_photo_path != null" :src="aws_path + captured_photo_path"
                                    max-width="200" /> -->
                                <!-- <div v-else>No photo available</div> -->
                            </v-col>
                            <v-col cols="12" sm="4" md="4" align="left">
                                <v-btn class="button" @click="clearPhoto">Clear Captured Photo</v-btn>
                            </v-col>
                        </v-row>
                        <br>
                        <v-row justify="center" dense v-if="captured_photo_path != null" style="margin-left: 77px;">
                            <v-btn @click="captureImage" :loading="capture_image_loader" color="warning">Upload
                                Photo</v-btn>
                        </v-row>
                    </v-div>

                </v-card-text>
               <v-card-text v-if="tab == 'photoinfo' && tenant != 'sanjivani'" class="box">
                    <v-row>
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                            <v-alert elevation="2" class="pt-1 pb-1 toolbar">
                                Photo <template v-if="show_signature">& Signature </template>Information for {{ org_name }}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <br />

                    <v-row justify="center">
                        <v-col cols="12" sm="6" md="6" class="pt-0 pb-0" :style="show_signature ? 'border-right: 1px solid #e0e0e0;' : ''">
                            <h3 class="text-center mb-3">Student Photo</h3>
                            <center v-if="photo_path">
                                <img :src="aws_path + photo_path" width="200px" height="200px" style="object-fit: cover;" />
                                <br />
                                <v-btn class="mx-2 mt-2" fab dark small color="primary" @click="downloadImg(aws_path + photo_path)">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                                <a target="_blank" :href="aws_path + photo_path" download="myimage">
                                    <v-icon>mdi-download</v-icon>
                                </a>
                            </center>

                            <div style="max-width: 400px; margin: 0 auto;">
                                <v-file-input id="newFile" ref="file" v-model="profile_image" accept="image/*"
                                    @change="handleFileChangeNew()"
                                    hint="Only jpg/jpeg allowed. Ideal dimension: 200x200px"
                                    persistent-hint label="Select Photo"></v-file-input>
                            </div>

                            <div class="text-center mt-4">
                                <p v-if="file" class="mb-1">File Height: {{ fileHeight }}, File Width: {{ fileWidth }}</p>
                                <b style="color:red; display:block;">File Should Be In {{ allowed_extensions }} Format And Size Should Be <= {{ imagesize }} MB</b>
                                <b style="color:red; display:block;" v-if="documentheight">Image Height Should Be <= {{ documentheight }} And Width Should Be <= {{ documentwidth }}</b>
                                
                                <v-btn @click="uploadImage" :disabled="!isvaliddimantions" :loading="upload_image_loader"
                                    color="warning" v-if="image_msg == null" class="mt-4">Upload Photo</v-btn>
                            </div>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="pt-0 pb-0" v-if="signRequires">
                            <h3 class="text-center mb-3">Student Signature</h3>
                            <center v-if="signature_path">
                                <img :src="aws_path + signature_path" width="200px" height="100px" style="object-fit: contain; border: 1px solid #ccc;" />
                                <br />
                                <v-btn class="mx-2 mt-2" fab dark small color="primary" @click="downloadImg(aws_path + signature_path)">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                                <a target="_blank" :href="aws_path + signature_path" download="signature">
                                    <v-icon>mdi-download</v-icon>
                                </a>
                            </center>

                            <div style="max-width: 400px; margin: 0 auto;">
                                <v-file-input id="sigFile" ref="sigFile" v-model="signature_image" accept="image/*"
                                    @change="handleSignatureChange()"
                                    hint="Upload signature jpg/jpeg/png allowed"
                                    persistent-hint label="Select Signature"></v-file-input>
                            </div>

                            <div class="text-center mt-4">
                                <p v-if="sigFile" class="mb-1">File Height: {{ sign_fileHeight }}, File Width: {{ sign_fileWidth }}</p>
                                <b style="color:red; display:block;" v-if="!signature_msg">File Should Be In jpg, jpeg, png Format And Size Should Be <= {{ sign_imagesize }} MB</b>
                                <v-btn @click="uploadSignature" :loading="signature_loader" color="warning" class="mt-4">Upload Signature</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- otherinfo -->
                <v-card-text v-if="tab == 'otherinfo'" class="box">
                    <v-row>
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Other Information </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </v-col>
                    </v-row>
                    <br />
                    <v-row>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <!-- :readonly="org_id == '3' && tenant == 'zeal' ? edit_student_quota_admission_year : false"
                            :filled="org_id == '3' && tenant == 'zeal' ? edit_student_quota_admission_year : false" -->
                            <p><b>Select Admission Year</b></p>
                            <v-autocomplete dense rounded outlined name="stud_admitted_year" class="ml-5 mr-5 pt-1"
                                v-model="stud_data.admissionyear_id" :items="stud_data.ay_list" item-text="ay"
                                item-value="id" label="Select Admission Year" persistent-hint
                                :disabled="show_ay == false"
                                hint="Changing admission year may change your fee structure"
                                single-line></v-autocomplete>
                        </v-col>
                        <!-- <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <p><br /></p>
                            <b> Date of Admission </b>::
                            <input type="date" id="admission_date" v-model="stud_data.admission_date" />
                        </v-col> -->
                        <v-col cols="12" sm="4" md="4">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="error">*</v-icon>
                                    <v-text-field dense rounded outlined
                                        @blur="date = parseDate(stud_data.admission_date)" hint="YYYY/MM/DD format"
                                        persistent-hint v-model.trim="stud_data.admission_date" label="Date Of Admission"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker style="height:400px" v-model="stud_data.admission_date"
                                    @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                            <v-menu v-model="menu22" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="error">*</v-icon>
                                    <v-text-field dense rounded outlined
                                        @blur="date = parseDate(stud_data.physical_date)" hint="YYYY/MM/DD format"
                                        persistent-hint v-model.trim="stud_data.physical_date"
                                        label="Date Of Physically Attended" prepend-icon="mdi-calendar" readonly
                                        v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker style="height:400px" v-model="stud_data.physical_date"
                                    @input="menu22 = false; convertToUnicode(stud_data.physical_date, 'unicode_physical_date')"></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0" v-if="stud_data.unicode_fields_in_edit_student && stud_data.unicode_fields_in_edit_student.required">
                            <p><b>Unicode Physical Date</b></p>
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.unicode_physical_date" name="unicode_physical_date"
                                label="Unicode Physical Date"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <p><b>Select Previous School Passing Standard</b></p>
                            <v-autocomplete dense rounded outlined class="ml-5 mr-5 pt-1"
                                v-model="stud_data.previousschoolpassingstandard_id" :items="stud_data.standard_list"
                                item-text="standard" item-value="id" label="Select Previous School Passing Standard"
                                persistent-hint single-line></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <p><b>Previous School Name</b></p>
                            <v-text-field rounded outlined dense
                                v-model.trim="stud_data.previous_school_name" name="stud_previous_school_name"
                                @input="convertToUnicode(stud_data.previous_school_name, 'unicode_previous_school_name')"
                                label="Previous School Name"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0" v-if="stud_data.unicode_fields_in_edit_student && stud_data.unicode_fields_in_edit_student.required">
                            <p><b>Unicode Previous School Name</b></p>
                            <v-text-field rounded outlined dense
                                v-model.trim="stud_data.unicode_previous_school_name" name="unicode_previous_school_name"
                                label="Unicode Previous School Name"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <p><b>Previous School Leaving Reason</b></p>
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.reason_for_leaving_last_school"
                                name="stud_reason_for_leaving_last_school"
                                label="Previous School Leaving Reason"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <p><b>Previous School Obtained Percentage</b></p>
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.previous_school_obtained_percentage"
                                name="stud_previous_school_obtained_percentage"
                                label="Previous School Obtained Percentage"></v-text-field>
                        </v-col>


                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <p><b>Select Admitted Standard</b></p>
                            <v-autocomplete dense rounded outlined name="stud_admittedstandard" class="ml-5 mr-5 pt-1"
                                v-model="stud_data.admittedstandard_id" :items="stud_data.standard_list"
                                item-text="standard" item-value="id" label="Select Standard" persistent-hint
                                single-line></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <p><b>Select Current Standard</b></p>
                            <v-autocomplete dense rounded outlined name="stud_currentstandard" class="ml-5 mr-5 pt-1"
                                v-model="stud_data.currentstandard_id" :items="stud_data.standard_list"
                                item-text="standard" item-value="id" label="Select Standard" persistent-hint
                                single-line></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <p><b>Select House</b></p>
                            <v-autocomplete dense rounded outlined name="stud_house" class="ml-5 mr-5 pt-1"
                                v-model="stud_data.house_id" :items="stud_data.house_list" item-text="name"
                                item-value="id" label="Select House" persistent-hint single-line></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <p><b>School Medium</b></p>
                            <v-text-field dense rounded outlined v-model.trim="stud_data.school_medium"
                                placeholder="Please add school medium" hint="English,Semi-English,Marathi">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <br />
                            <!-- <v-row justify="center" dense> -->
                            <v-switch color="#0F2027" v-model="stud_data.is_admitted_for_term_1"
                                label="Is Admitted For Term 1"></v-switch>
                            <!-- </v-row> -->
                        </v-col>
                        <v-col>
                            <input type="hidden" :value="otherData" name="otherData" />
                        </v-col>
                    </v-row>
                    <div class="text-center">
                        <v-btn class="button" :loading="save_loader" @click="saveOther">Save</v-btn>
                    </div>

                    <v-row>
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pb-0">
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Transport Driver Information </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </v-col>
                    </v-row>
                    <br />
                    <v-row>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <p><b>Name</b></p>
                            <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.driver_name"
                                name="driver_name" label="Driver Name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <p><b>Aadhaar No</b></p>
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.driver_aadhar_no" name="driver_aadhar_no"
                                label="Driver Aadhaar No"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <p><b>Mobile No</b></p>
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.driver_mobile_no" name="driver_mobile_no"
                                label="Driver Mobile No"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <p><b>Transportaion Mode</b></p>
                            <v-autocomplete dense v-model="stud_data.transportaion_mode" rounded outlined
                                color="#0F2027" :items="stud_data.transportaion_mode_list" item-text="name"
                                item-value="id" persistent-hint></v-autocomplete>

                        </v-col>
                    </v-row>
                    <v-row dense justify="center">
                        <v-col cols="12" sm="10" md="12">
                            <v-textarea dense :value="stud_data.driver_address" v-model="stud_data.driver_address"
                                name="driver_address" hint="Driver Address" persistent-hint outlined></v-textarea>
                        </v-col>
                        <v-col>
                            <input type="hidden" :value="driverData" name="driverData" />
                        </v-col>
                    </v-row>
                    <div class="text-center">
                        <v-btn class="button" :loading="save_loader" @click="saveDriverInfo">Save</v-btn>
                    </div>
                </v-card-text>
                <!-- document -->
                <v-card-text v-if="tab == 'documents'" class="box">
                    <v-row dense justify="center">
                        <v-col cols="4" sm="4" md="4">
                            <v-autocomplete dense :items="document_type_list" item-value="id" item-text="name"
                                v-model="documenttype" :required="true"
                                :rules="true ? [(v) => !!v || 'Document type is required'] : []"
                                :clearable="true ? false : true" single-line
                                :prepend-icon="true ? 'mdi-file' : 'mdi-file'" outlined
                                hint="Select the type of document" persistent-hint
                                @change="getDocumentConfig(documenttype)"></v-autocomplete>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                            <template>
                                <v-file-input @change="handleFileChange" :required="true" prepend-icon="mdi-attachment"
                                    label="Choose File" show-size v-model="file" name="doc"></v-file-input>
                            </template>
                            <p v-if="file">File Height: {{ fileHeight }}, File Width: {{ fileWidth }}</p>
                        </v-col>

                        <v-col cols="2" sm="2" md="2">
                            <v-btn class="ma-2" :color="file ? 'primary darken-1' : 'grey lighten-1'"
                                @click="uploadDocument()" :disabled="!file || !isvaliddimantions"
                                :loading="upload_image_loader"> <v-icon dark>
                                    mdi-cloud-upload
                                </v-icon> Upload </v-btn>
                        </v-col>
                    </v-row>
                    <v-row dense justify="center" v-if="req_imagetype_doc">
                        <b style="color:red"> File Should Be In {{ req_imagetype_doc }} Format And Size Of Uploading
                            Documents Should Be <= {{ req_imagetype_size }} MB </b>
                    </v-row>
                    <v-row dense justify="center" v-if="documentheight">
                        <b style="color:red"> image Height Should Be <= {{ documentheight }} And Width Should Be <={{
                                documentwidth }} </b>
                    </v-row>

                </v-card-text>
                <v-card-text v-if="tab == 'documents'" class="box">
                    <v-row dense justify="center" v-if="stud_data.doc_list.length > 0">
                        <v-col cols="10" sm="10" md="10">
                            <template>
                                <v-card class="box">
                                    <v-simple-table fixed-header>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Document Name</th>
                                                    <th class="text-left">Download File</th>
                                                    <th class="text-left">Delete File</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in stud_data.doc_list" :key="i">
                                                    <td>{{ item.doc_name }}</td>

                                                    <td>
                                                        <v-btn text color="primary" icon title="download">
                                                            <a :href="aws_path + item.doc_path" target="_blank"
                                                                style="text-decoration: none;">
                                                                <v-icon>mdi-file-download</v-icon>
                                                            </a>
                                                        </v-btn>
                                                    </td>
                                                    <td>
                                                        <v-btn text title="Delete File" :loading="delete_load"
                                                            @click="deleteAttachment(item)">
                                                            <v-icon color="red">mdi-window-close</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card>
                            </template>
                        </v-col>
                    </v-row>
                    <div style="text-align: center; color: red;" v-else>
                        <span>No Documents found!</span>
                    </div>
                </v-card-text>
                <!-- history -->
                <v-card-text v-if="tab == 'history'" class="box">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="12" md="12">
                            <v-data-table :headers="headers" :items="stud_data.payment_history"
                                class="elevation-1 mytable" dense>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- health -->
                <v-card-text v-if="tab == 'health'" class="box">
                    <v-row>
                        <v-col cols="12" sm="12" md="12" colored-border color="deep-purple accent-4" class="pt-0 pb-0">
                            <v-alert elevation="2" class="pt-1 pb-1 toolbar">Health Details</v-alert>
                        </v-col>
                    </v-row>
                    <br />
                    <!-- {{stud_data}} -->
                    <v-row>
                        <v-col cols="12" sm="1" md="1" colored-border color="deep-purple accent-4"
                            class="pt-0 pb-0"></v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
                            <p><b>Any Difficulty In Hearing</b></p>
                            <v-radio-group v-model="stud_data.difficulty_in_hearing" mandatory row
                                class="ma-2 no-display">
                                <v-radio label="Yes" value="True" color="#0f2027"
                                    name="difficulty_in_hearing"></v-radio>
                                <v-radio label="No" value="False" color="#0f2027"
                                    name="difficulty_in_hearing"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
                            <p><b>Any Difficulty In Vision</b></p>
                            <v-radio-group v-model="stud_data.difficulty_in_vision" mandatory row
                                class="ma-2 no-display">
                                <v-radio label="Yes" value="True" color="#0f2027" name="difficulty_in_vision"></v-radio>
                                <v-radio label="No" value="False" color="#0f2027" name="difficulty_in_vision"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
                            <p><b>Any Difficulty In Speech</b></p>
                            <v-radio-group v-model="stud_data.difficulty_in_speech" mandatory row
                                class="ma-2 no-display">
                                <v-radio label="Yes" value="True" color="#0f2027" name="difficulty_in_speech"></v-radio>
                                <v-radio label="No" value="False" color="#0f2027" name="difficulty_in_speech"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
                            <p><b>Any Difficulty In Learning</b></p>
                            <v-radio-group v-model="stud_data.difficulty_in_learning" mandatory row
                                class="ma-2 no-display">
                                <v-radio label="Yes" value="True" color="#0f2027"
                                    name="difficulty_in_learning"></v-radio>
                                <v-radio label="No" value="False" color="#0f2027"
                                    name="difficulty_in_learning"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 pb-0">
                            <p><b>Any Difficulty In Motor</b></p>
                            <v-radio-group v-model="stud_data.difficulty_in_motor" mandatory row
                                class="ma-2 no-display">
                                <v-radio label="Yes" value="True" color="#0f2027" name="difficulty_in_motor"></v-radio>
                                <v-radio label="No" value="False" color="#0f2027" name="difficulty_in_motor"></v-radio>
                            </v-radio-group>
                        </v-col>

                    </v-row>
                    <v-row dense justify="center">
                        <v-col cols="12" sm="1" md="1" colored-border color="deep-purple accent-4"
                            class="pt-0 pb-0"></v-col>
                        <v-col cols="10" sm="10" md="10">
                            <v-textarea dense :value="stud_data.immunization" v-model="stud_data.immunization"
                                name="immunization" hint="Immunization If Any" persistent-hint outlined></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row dense justify="center">
                        <v-col cols="12" sm="1" md="1" colored-border color="deep-purple accent-4"
                            class="pt-0 pb-0"></v-col>
                        <v-col cols="10" sm="10" md="10">
                            <v-textarea dense :value="stud_data.past_medical_surgery_emergency"
                                v-model="stud_data.past_medical_surgery_emergency" name="past_medical_surgery_emergency"
                                hint="Surgeries(if any)" persistent-hint outlined></v-textarea>
                        </v-col>
                        <v-col>
                            <input type="hidden" :value="health_data" name="health_data" />
                        </v-col>
                    </v-row>
                    <div class="text-center">
                        <v-btn class="button" :loading="save_loader" @click="saveHealthInfo">Save</v-btn>
                    </div>

                    <hr>
                    <br>
                    <center v-if="health_card_details.length > 0">
                        <strong>Download Uploaded Files </strong>
                        <span v-for="hc, index in health_card_details" :key="index">
                            <a target="_blank" :href="aws_path + hc.health_card"
                                download="health_card_details">
                            <v-chip small style="margin-left: 10px;" medium>
                                <v-icon medium >mdi-download</v-icon>{{hc.name}}</v-chip>
                            </a>
                            <v-icon @click='deleteDocument(hc,index)' style="color: red;">mdi-trash-can</v-icon>
                        </span>
                    </center>
                    <br>
                    <v-row>
                        <v-col cols="12" sm="4" md="4">
                            <!-- <v-file-input v-model="health_card" persistent-hint label="Upload health report"
                            multiple  hint="Please select file">
                        </v-file-input> -->
                            <v-file-input class="pt-8" v-model="health_card" placeholder="Upload attachment if any"
                                label="Attachment" prepend-icon="mdi-paperclip" multiple>
                                <template v-slot:selection="{ text , index }">
                                    <v-chip small label color="primary" close @click:close="removeHealthCard(index)">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            Document Name<v-icon class="pb-2" color="error">*</v-icon>
                            <v-text-field class="pa-0" dense v-model.trim="documentname" hide-details
                                persistent-hint></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" dense>
                        <v-btn @click="uploadHealthDetails" :loading="upload_image_loader" color="warning"
                            v-if="health_card && documentname">Upload
                            Health Report</v-btn>

                    </v-row>
                    <br />
                    <br />
                    <!-- {{child_div_id}} -->
                    <div class="text-center">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="getPrint()">
                            <v-icon left>mdi-printer</v-icon>GetPrint
                            <v-icon right></v-icon>
                        </v-btn>
                    </div>
                    <br />
                    <student-health-card v-if="child_div_id != null && tenant == 'sbpps'" :child_div_id="child_div_id"
                        :key="child_div_id" />
                </v-card-text>
                <v-card-text v-if="tab == 'awards'" class="box">
                    <!-- <v-row dense>
                            <span class="slide">
                                Note* : File size should be less than {{ sizelimit / 1000000 }}MB! and
                                File should be in
                                <span v-for="(type, index) in allowed_extensions" in :key="index">
                                {{ type }}</span
                                >
                                Format!
                            </span>
                         </v-row>
                          <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Award Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            </v-toolbar>
                             <v-data-table
      :headers="headers"
      :items="instructor_awards_list"
      class="elevation-1 mytable"
      dense
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat dense color="white">
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on }">
              <v-btn class="button" v-on="on" small>Add Award Details</v-btn>
            </template>
            <v-card>
              <v-card-title class="toolbar">
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="title"
                        label="Title *"
                        placeholder="Please enter Title"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="title"
                        label="Title *"
                        placeholder="Please enter Title"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                      <v-textarea
                        rows="2"
                        clearable
                        counter
                        label="Description"
                        :rules="rules"
                        outlined
                        v-model="description"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                      <v-textarea
                        clearable
                        rows="2"
                        counter
                        label="Description"
                        :rules="rules"
                        outlined
                        v-model="description"
                      ></v-textarea>
                    </v-col>

                    <v-col cols="4" sm="4" md="4" v-if="editedIndex != -1">
                      <v-file-input
                        rounded
                        label="Award Document"
                        outlined
                        dense
                        placeholder="Optional"
                        v-model="edit_award_letter"
                        @change="validateAwardLetter()"
                        :hint="
                          edit_award_letter == null
                            ? 'File should be in given format'
                            : 'File selected'
                        "
                      ></v-file-input>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        :items="academicyear_list"
                        item-text="academicyear"
                        item-value="ay_id"
                        v-model="academicyear"
                        name="academicyear"
                        label="Academic Year *"
                        placeholder="Select Academic Year"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="editedIndex != -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        :items="academicyear_list"
                        item-text="academicyear"
                        v-model="academicyear"
                        label="Academic Year *"
                        placeholder="Select Academic Year"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="button" @click="close">Cancel</v-btn>
                <v-btn class="button" @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.award_letter="{ item }">
        <span v-if="item.award_letter != 'NA'">
          <a :href="aws_path + item.award_letter" target="_blank"> View </a>
        </span>
        <span v-else> NA </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
              >edit</v-icon
            >
          </v-avatar>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon
              color="error"
              class="delete-v-icon mr-2"
              @click="deleteItem(item)"
              >delete</v-icon
            >
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please wait..
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div> -->
                    <student-awards :child_div_id="child_div_id" :key="child_div_id" />
                </v-card-text>
            </v-form>
        </v-col>

        <v-dialog v-model="cropDialog" max-width="700px">
            <v-card>
                <v-card-title>Crop Image</v-card-title>

                <v-card-text>
                <div ref="imageContainer" style="position: relative; display: inline-block;">
                    <img ref="cropImage" :src="cropImageSrc" style="max-width:100%; display:block;" @load="initializeCrop" />

                    <div class="crop-box" :style="cropStyle" @mousedown.prevent="startMove">
                    <div class="resize top" @mousedown.stop.prevent="startResize('top')"></div>
                    <div class="resize bottom" @mousedown.stop.prevent="startResize('bottom')"></div>
                    <div class="resize left" @mousedown.stop.prevent="startResize('left')"></div>
                    <div class="resize right" @mousedown.stop.prevent="startResize('right')"></div>

                    <div class="corner top-left" @mousedown.stop.prevent="startResize('top-left')">
                        <span class="hor"></span>
                        <span class="ver"></span>
                    </div>

                    <div class="corner top-right" @mousedown.stop.prevent="startResize('top-right')">
                        <span class="hor"></span>
                        <span class="ver"></span>
                    </div>

                    <div class="corner bottom-left" @mousedown.stop.prevent="startResize('bottom-left')">
                        <span class="hor"></span>
                        <span class="ver"></span>
                    </div>

                    <div class="corner bottom-right" @mousedown.stop.prevent="startResize('bottom-right')">
                        <span class="hor"></span>
                        <span class="ver"></span>
                    </div>

                    </div>
                </div>
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="applySquareCrop">Crop</v-btn>
                <v-btn text @click="cropDialog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
    import StudentHealthCard from "../../HealthCard/StudentHealthCard.vue";
    import Awards from "./StudentAwards.vue";
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import moment from "moment";

    export default {
        components: {
            "student-health-card": StudentHealthCard,
            "student-awards": Awards,
        },
        props: {
            lid: Number,
        },
        name: "CameraDialog",
        data() {

            return {
                cast_cert: null,
                dialog_upload: false, editedIndex: -1,
                academicyear_list: [],
                health_data: true,
                difficulty_in_hearing: false,
                difficulty_in_vision: false,
                difficulty_in_speech: false,
                difficulty_in_motor: false,
                difficulty_in_learning: false,
                capture_image_loader: false,
                documenttype: "",
                file: null,
                isValid: false,
                menu: false,
                dialog: false,
                modal: false,
                modal2: false,
                modal3: false,
                menu22: false,
                menu2: false,
                menu3: false,
                menu11: false,
                learnerDivision_id: "",
                upload_image_loader: false,
                image_msg: null,
                allowed_extensions: ["jpg", "jpeg", "JPG", "JPEG", "png", "PNG"],
                profile_image: null,
                health_card: null,
                health_msg: null,
                photo_path: null,
                video: null,
                canvas: null,
                captures: null,
                photo: null,
                captured_photo_path: null,
                captured_photo_name: null,
                health_card_details: null,
                documentname: null,
                aws_path: null,
                tenant: null,
                org_id: null,
                org_name: null,
                tab: "basic",
                load_tab: true,
                stud_data: "",
                category: {},
                religion: {},
                cast: {},
                domacile: {},
                country: {},
                date: new Date().toISOString().substr(0, 10),
                menu1: false,
                basicData: true,
                otherData: true,
                driverData: true,
                castData: true,
                contactData: true,
                addressData: true,
                relativeData: true,
                critical_edit: false, //check for employee or parent to edit critical field
                edit_student_quota_admission_year: false, // for Edit Student Quota And  Admission Year
                edit_student_gr_no_prefix: false, // for Grno Non 0 Prefix
                snackbar_msg: "",
                color: "",
                snackbar: false,
                pladdress: null,
                StudFullName: null,
                delete_load: false,
                s3url: "",
                payment_history: "",
                raise_issue: null,
                document_type_list: [],
                country_list: [],
                state_list: [],
                cities_list: [],
                cities_list_local: [],
                cities_list_permanant: [],
                district_list: [],
                sibling1: null,
                sibling2: null,
                select_photo_type: "upload",
                relationtype_list: ['Brother', 'Sister'],
                standard_list: [],
                imagesize: null,
                imagetype: null,
                imageTypeFlag: false,
                imageSizeFlag: false,
                headers: [
                    {
                        text: "Sr. No.",
                        align: "left",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Learner",
                        align: "left",
                        sortable: false,
                        value: "learner",
                    },
                    {
                        text: "Amount",
                        align: "left",
                        sortable: false,
                        value: "amount",
                    },
                    {
                        text: "Paid For",
                        align: "left",
                        sortable: false,
                        value: "purpose",
                    },
                    {
                        text: "Order Id",
                        align: "left",
                        sortable: true,
                        value: "order_id",
                    },
                    {
                        text: "Transaction Id",
                        align: "left",
                        sortable: true,
                        value: "trxn_id",
                    },
                    {
                        text: "Transaction Date",
                        value: "transaction_date",
                        sortable: false,
                    },
                    {
                        text: "Payment Status",
                        value: "paymenttransactionstatus",
                        sortable: false,
                    },
                    { text: "Payment Mode", value: "mode", sortable: false },
                ],
                child_div_id: null,
                save_loader: false,
                family_type_list: [], language_list: [],
                fileHeight: null,
                fileWidth: null,
                req_imagetype_doc: null,
                req_imagetype_size: null, isvaliddimantions: true, isdimentionrequired: false, documentheight: null, documentwidth: null,
                formatted_dob: false,
                show_quota: null,
                show_ay: null,
                cropDialog: false,
                cropImageSrc: null,
                cropTop: 0,
                cropLeft: 0,
                cropWidth: 200,
                cropHeight: 200,
                moving: false,
                resizing: null,
                cropImageUrl: null,
                originalFile: null,
                facingMode: "user",
                hasMultipleCameras: false,
                sigFile: null,
                signature_image:null,
                signRequires:false,
                sign_height:null,
                sign_width:null,
                sign_imagesize:null,
                sign_imagetype:null,
                sign_isdimentionrequired:null,
                sign_fileHeight:null,
                sign_fileWidth:null,
                currentCropType: null,
                signature_photo_path:null,
                signature_loader:false,
                disabled_gr_number:false,
            };
        },
        computed: {
            formattedDate: {
                get() {
                    if (this.formatted_dob && this.stud_data.stud_date_of_birth != null) {
                        const [day, month, year] = this.stud_data.stud_date_of_birth.split("-");
                        return `${year}-${month}-${day}`;
                    }
                    return this.stud_data.stud_date_of_birth;
                },
                set(value) {
                    if (this.formatted_dob && this.stud_data.stud_date_of_birth != null) {
                        const [year, month, day] = value.split("-");
                        this.stud_data.stud_date_of_birth = `${day}-${month}-${year}`;
                    } else {
                        this.stud_data.stud_date_of_birth = value;
                    }
                },
            },
            cropStyle() {
                return {
                    position: "absolute",
                    top: this.cropTop + "px",
                    left: this.cropLeft + "px",
                    width: this.cropWidth + "px",
                    height: this.cropHeight + "px",
                    border: "2px dotted red",
                    boxSizing: "border-box",
                    zIndex: 5
                }
            }
        },
        created() {
            this.aws_path = localStorage.getItem("awspath");
            this.tenant = localStorage.getItem("EPS-tenant");
            this.org_id = localStorage.getItem("EPS-org-id");
            this.org_name = localStorage.getItem("EPS-org-name");
        },
        mounted() {
            this.getData();
        },
        watch: {
            lid() {
                this.getData();
            },
            date(val) {
                this.stud_data.date_of_birth.field_value = this.formatDate(this.date);
            },
            dialog(newVal) {
                if (newVal) {
                    this.initCamera();
                } else {
                    this.stopCamera();
                }
            }
        },
        methods: {
            // async convertToUnicode(text, targetField) {
            //     if (!targetField) return

            //     let value = text || ''

            //     if (!value) {
            //         this.stud_data[targetField] = ''
            //         return
            //     }

            //     const res = await fetch(
            //         "https://inputtools.google.com/request?text=" +
            //         encodeURIComponent(value) +
            //         "&itc=mr-t-i0-und&num=1"
            //     )

            //     const data = await res.json()

            //     if (data[0] === "SUCCESS") {
            //         this.stud_data[targetField] = data[1][0][1][0]
            //     }
            // },
            async convertToUnicode(text, targetField) {
                if (!targetField) return;

                if (!text) {
                    this.stud_data[targetField] = "";
                    return;
                }

                const parts = text.split(",");

                const convertedParts = await Promise.all(
                    parts.map(async (part) => {
                        part = part.trim();

                        if (!part) return "";

                        const res = await fetch(
                            "https://inputtools.google.com/request?text=" +
                            encodeURIComponent(part) +
                            "&itc=mr-t-i0-und&num=1"
                        );

                        const data = await res.json();

                        if (data[0] === "SUCCESS") {
                            return data[1][0][1][0].normalize("NFC");
                        }

                        return part.normalize("NFC");
                    })
                );

                this.stud_data[targetField] = convertedParts.join(", ").normalize("NFC");
            },
        //    applySquareCrop() {
        //     const img = this.$refs.cropImage
        //     let size

        //     if (this.documentheight) {
        //         size = this.documentheight
        //     } else {
        //         // fallback if no restriction
        //         size = Math.min(this.cropWidth, this.cropHeight)
        //     }

        //     const canvas = document.createElement("canvas")
        //     canvas.width = size
        //     canvas.height = size

        //     const ctx = canvas.getContext("2d")

        //     ctx.drawImage(
        //         img,
        //         this.cropLeft,
        //         this.cropTop,
        //         this.cropWidth,
        //         this.cropHeight,
        //         0,
        //         0,
        //         size,
        //         size
        //     )

        //     canvas.toBlob((blob) => {
        //         if (!blob) return

        //         const croppedFile = new File(
        //             [blob],
        //             this.originalFile.name,
        //             { type: this.originalFile.type }
        //         )

        //         this.profile_image = croppedFile
        //         this.file = croppedFile
        //         this.fileHeight = canvas.height
        //         this.fileWidth = canvas.width
        //         this.cropDialog = false
        //     })
        // },
        
        applySquareCrop() {
            const img = this.$refs.cropImage;
            if (!img) return;

            // 1. Calculate the scale difference between original image and screen display
            const scaleX = img.naturalWidth / img.clientWidth;
            const scaleY = img.naturalHeight / img.clientHeight;

            // 2. Convert the UI display coordinates into real natural pixels
            const realLeft = this.cropLeft * scaleX;
            const realTop = this.cropTop * scaleY;
            const realWidth = this.cropWidth * scaleX;
            const realHeight = this.cropHeight * scaleY;

            // let size;
            // if (this.documentheight) {
            //     size = this.documentheight;
            // } else {
            //     // Fallback if no strict restriction: match the bounding box length safely
            //     size = Math.min(realWidth, realHeight);
            // }
            let targetWidth, targetHeight;
    
            if (this.currentCropType === 'photo') {
                targetHeight = this.documentheight ? this.documentheight : Math.min(realWidth, realHeight);
                targetWidth = this.documentwidth ? this.documentwidth : targetHeight;
            } else if (this.currentCropType === 'signature') { 
                targetHeight = this.sign_height ? this.sign_height : realHeight;
                targetWidth = this.sign_width ? this.sign_width : realWidth;
            } else if (this.currentCropType === 'document') { 
                targetHeight = this.documentheight ? this.documentheight : realHeight;
                targetWidth = this.documentwidth ? this.documentwidth : realWidth;
            } else {
                targetHeight = realHeight;
                targetWidth = realWidth;
            }

            const canvas = document.createElement("canvas");
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            const ctx = canvas.getContext("2d");

            // 3. Draw using the calculated natural/real pixel coordinates
            ctx.drawImage(
                img,
                realLeft,   // sx (source x)
                realTop,    // sy (source y)
                realWidth,  // sw (source width)
                realHeight, // sh (source height)
                0,          // dx
                0,          // dy
                targetWidth,  // dw
                targetHeight, // dh
            );

            canvas.toBlob((blob) => {
                if (!blob) return;

                const croppedFile = new File(
                    [blob],
                    this.originalFile.name,
                    { type: this.originalFile.type }
                );

                // this.profile_image = croppedFile;
                // this.file = croppedFile;
                // this.fileHeight = canvas.height;
                // this.fileWidth = canvas.width;
                if (this.currentCropType === 'photo') {
                    this.profile_image = croppedFile;
                    this.file = croppedFile;
                    this.fileHeight = canvas.height;
                    this.fileWidth = canvas.width;
                } else if (this.currentCropType === 'signature') {
                    this.signature_image = croppedFile;
                    this.sigFile = croppedFile;
                    this.sign_fileHeight = canvas.height;
                    this.sign_fileWidth = canvas.width;
                } else if (this.currentCropType === 'document') { 
                    this.file = croppedFile;
                    this.fileHeight = canvas.height;
                    this.fileWidth = canvas.width;
                }
                this.cropDialog = false;
            }, this.originalFile.type || "image/jpeg");
        },
        
        startMove() {
            this.moving = true;
            document.addEventListener("mousemove", this.moveSquare);
            document.addEventListener("mouseup", this.stopMove);
        },

        removeHealthCard(index) {
            this.health_card.splice(index, 1);
        },

        moveSquare(e) {
        if (!this.moving) return;

        const container = this.$refs.imageContainer.getBoundingClientRect();

        let x = e.clientX - container.left - this.cropWidth / 2;
        let y = e.clientY - container.top - this.cropHeight / 2;

        const img = this.$refs.cropImage;

        x = Math.max(0, Math.min(x, img.width - this.cropWidth));
        y = Math.max(0, Math.min(y, img.height - this.cropHeight));

        this.cropLeft = x;
        this.cropTop = y;
        },

        stopMove() {
        this.moving = false;
        document.removeEventListener("mousemove", this.moveSquare);
        document.removeEventListener("mouseup", this.stopMove);
        },

        startResize(direction) {
        this.resizing = direction;
        document.addEventListener("mousemove", this.resizeCrop);
        document.addEventListener("mouseup", this.stopResize);
        },

        stopResize() {
        this.resizing = null;
        document.removeEventListener("mousemove", this.resizeCrop);
        document.removeEventListener("mouseup", this.stopResize);
        },

        resizeCrop(e) {
        if (!this.resizing) return;

        const img = this.$refs.cropImage;
        const rect = img.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        switch (this.resizing) {
            case "top":
            let diffTop = this.cropTop - mouseY;
            this.cropTop = mouseY;
            this.cropHeight += diffTop;
            break;
            case "bottom":
            this.cropHeight = mouseY - this.cropTop;
            break;
            case "left":
            let diffLeft = this.cropLeft - mouseX;
            this.cropLeft = mouseX;
            this.cropWidth += diffLeft;
            break;
            case "right":
            this.cropWidth = mouseX - this.cropLeft;
            break;

            // Corners
            case "top-left":
            let diffTLX = this.cropLeft - mouseX;
            let diffTLY = this.cropTop - mouseY;
            this.cropLeft = mouseX;
            this.cropTop = mouseY;
            this.cropWidth += diffTLX;
            this.cropHeight += diffTLY;
            break;
            case "top-right":
            let diffTRX = mouseX - (this.cropLeft + this.cropWidth);
            let diffTRY = this.cropTop - mouseY;
            this.cropTop = mouseY;
            this.cropWidth += diffTRX;
            this.cropHeight += diffTRY;
            break;
            case "bottom-left":
            let diffBLX = this.cropLeft - mouseX;
            let diffBLY = mouseY - (this.cropTop + this.cropHeight);
            this.cropLeft = mouseX;
            this.cropWidth += diffBLX;
            this.cropHeight += diffBLY;
            break;
            case "bottom-right":
            this.cropWidth = mouseX - this.cropLeft;
            this.cropHeight = mouseY - this.cropTop;
            break;
        }

            // Prevent going outside image
            if (this.cropLeft < 0) this.cropLeft = 0
            if (this.cropTop < 0) this.cropTop = 0

            if (this.cropLeft + this.cropWidth > img.width) {
                this.cropWidth = img.width - this.cropLeft
            }

            if (this.cropTop + this.cropHeight > img.height) {
                this.cropHeight = img.height - this.cropTop
            }

        },
        initializeCrop() {
        const imageEl = this.$refs.cropImage
        if (!imageEl) return

        const imgWidth = imageEl.clientWidth
        const imgHeight = imageEl.clientHeight

        // Example dynamic size
        this.cropWidth = imgWidth * 0.6
        this.cropHeight = imgHeight * 0.6

        this.cropLeft = (imgWidth - this.cropWidth) / 2
        this.cropTop = (imgHeight - this.cropHeight) / 2
        },


            clearPhoto() {
                this.photo = null;
                this.captured_photo_path = null;
                this.captured_photo_name = null;

            },
            // initCamera() {
            //     this.$nextTick(() => {
            //         this.video = this.$refs.video;
            //         if (this.video && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            //             navigator.mediaDevices.getUserMedia({ video: true })
            //                 .then((stream) => {
            //                     this.video.srcObject = stream;
            //                     this.video.play();
            //                 })
            //                 .catch((error) => {
            //                     console.error("Error accessing camera:", error);
            //                     alert("Unable to access the camera. Please check permissions.");
            //                     this.dialog = false;
            //                 });
            //         } else {
            //             console.error("Video element or mediaDevices API is not available.");
            //         }
            //     });
            // },
         async initCamera() {
                this.$nextTick(async () => {
                    try {
                    this.video = this.$refs.video;

                    if (this.video && this.video.srcObject) {
                        this.video.srcObject.getTracks().forEach(track => track.stop());
                        this.video.srcObject = null;
                    }

                    const constraints = {
                        video: { facingMode: this.facingMode },
                        audio: false
                    };

                    const stream = await navigator.mediaDevices.getUserMedia(constraints);
                    this.video.srcObject = stream;

                    const devices = await navigator.mediaDevices.enumerateDevices();
                    const videoDevices = devices.filter(d => d.kind === "videoinput");
                    this.hasMultipleCameras = videoDevices.length > 1;

                    } catch (error) {
                    console.error("Error accessing camera:", error);
                    alert("Unable to access camera");
                    this.dialog = false;
                    }
                });
            },
            switchCamera() {
                this.facingMode = this.facingMode === "user" ? "environment" : "user";
                this.initCamera();
            },
            stopCamera() {
                if (this.video && this.video.srcObject) {
                    this.video.srcObject.getTracks().forEach((track) => track.stop());
                    this.video.srcObject = null;
                }
            },
            captureImage() {
                if (this.captured_photo_path == null) {
                    this.capture_msg = "Please select image";
                    return;
                }

                let formData = new FormData();
                formData.append("ldid", this.learnerDivision_id);
                formData.append("registration_number", this.stud_data.registration_number);
                formData.append("captured_photo_path", this.captured_photo_path);
                formData.append("captured_photo_name", this.captured_photo_name);

                this.capture_image_loader = true;
                axios
                    .post("/parent/saveChildCapturePhoto", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("success", res.data.snackbar);
                            this.captured_photo_path = res.data.captured_photo_path;

                            this.photo_path = res.data.photo_path;
                            this.clearPhoto();
                        } else if (res.data.status == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);

                        }
                        else {
                            this.showSnackbar("error", res.data.snackbar);
                        }
                        this.capture_image_loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.capture_image_loader = false;
                    })
                    .finally(() => {
                        this.capture_image_loader = false;
                    });
            },
            stop() {
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    if (this.video.srcObject) {
                        this.video.srcObject.getTracks().forEach(track => track.stop());
                        this.video.srcObject = null;
                    }
                }
            },
            srcToFile(src, fileName, mimeType) {
                return fetch(src)
                    .then(function (res) {
                        return res.arrayBuffer();
                    })
                    .then(function (buf) {
                        return new File([buf], fileName, { type: mimeType });
                    });
            },
            capture() {
                this.canvas = this.$refs.canvas;
                const context = this.canvas.getContext("2d");
                context.drawImage(this.$refs.video, 0, 0, this.canvas.width, this.canvas.height);
                this.saveimage();
            },
            saveimage() {
                const image = this.canvas.toDataURL("image/png");
                const fd = new FormData();

                this.srcToFile(image, "photo.png", "image/png")
                    .then(file => {
                        fd.append("doc", file);
                        return axios.post("/parent/capturePhotoforicard", fd, {
                            headers: { "Content-Type": "multipart/form-data" },
                        });
                    })
                    .then(res => {
                        if (res.data.flag === "YES") {
                            this.captured_photo_path = res.data.captured_photo_path;
                            this.captured_photo_name = res.data.captured_photo_name;
                            this.showSnackbar("#4caf50", "Photo captured successfully...!");
                            this.dialog = false;
                        } else {
                            alert("Something went wrong!");
                            this.dialog = false;
                        }
                    })
                    .catch(error => {
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.stop();
                    });
            },

            updateDate() {
                if (this.formatted_dob && this.stud_data.stud_date_of_birth) {
                    const [day, month, year] = this.stud_data.stud_date_of_birth.split("-");
                    this.stud_data.stud_date_of_birth = `${day}-${month}-${year}`;
                }
            },
            // handleFileChangeNew() {
            //     if (this.isdimentionrequired == false) {
            //         return
            //     }
            //     const selectedFile = this.profile_image
            //     if (selectedFile) {
            //         this.file = selectedFile;
            //         this.originalFile = selectedFile; 
            //         const reader = new FileReader();
            //         reader.onload = (e) => {
            //             const img = new Image();
            //             img.onload = () => {
            //                 this.fileHeight = img.height;
            //                 this.fileWidth = img.width;
            //                 // alert(this.fileHeight)
            //                 // alert(this.documentheight)
            //                 // alert(this.fileWidth)
            //                 // alert(this.documentwidth)
            //                 if (this.fileHeight > this.documentheight || this.fileWidth > this.documentwidth) {
            //                     alert("Height And Width Not Matching..")
            //                     this.isvaliddimantions = false
            //                 } else {
            //                     this.isvaliddimantions = true
            //                     this.cropImageSrc = e.target.result
            //                     this.cropDialog = true
            //                 }
            //             };
            //             img.src = e.target.result;
            //         };
            //         reader.readAsDataURL(selectedFile);

            //     }


            // },
            // handleFileChange() {
            //     if (this.isdimentionrequired == false) {
            //         return
            //     }
            //     const selectedFile = this.file
            //     if (selectedFile) {
            //         this.file = selectedFile;
            //         this.originalFile = selectedFile
            //         const reader = new FileReader();
            //         reader.onload = (e) => {
            //             const img = new Image();
            //             img.onload = () => {
            //                 this.fileHeight = img.height;
            //                 this.fileWidth = img.width;
            //                 if (this.fileHeight > this.documentheight || this.fileWidth > this.documentwidth) {
            //                     alert("Height And Width Not Matching..")
            //                     this.isvaliddimantions = false
            //                 } else {
            //                     this.isvaliddimantions = true
            //                     this.cropImageSrc = e.target.result
            //                     this.cropDialog = true
            //                 }
            //             };
            //             img.src = e.target.result;
            //         };
            //         reader.readAsDataURL(selectedFile);

            //     }


            // },
          
            handleFileChangeNew() {
                const selectedFile = this.profile_image;
                if (!selectedFile) return;

                this.currentCropType = 'photo';
                this.file = selectedFile;
                this.originalFile = selectedFile;

                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        this.fileHeight = img.height;
                        this.fileWidth = img.width;

                        if (this.isdimentionrequired) {
                            if (this.fileHeight > this.documentheight || this.fileWidth > this.documentwidth) {
                                alert("Height And Width Not Matching..");
                                this.isvaliddimantions = false;
                                return;
                            }
                        }
                        this.isvaliddimantions = true;
                        this.cropImageSrc = e.target.result;
                        this.cropDialog = true;
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(selectedFile);
            },

            handleSignatureChange() {
                const selectedFile = this.signature_image;
                if (!selectedFile) return;

                this.currentCropType = 'signature';
                this.sigFile = selectedFile;
                this.originalFile = selectedFile;

                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        this.sign_fileHeight = img.height;
                        this.sign_fileWidth = img.width;

                        if (this.sign_isdimentionrequired) {
                            if (this.sign_fileHeight > this.sign_height || this.sign_fileWidth > this.sign_width) {
                                alert("Height And Width Not Matching..");
                                this.isvaliddimantions = false;
                                return;
                            }
                        }

                        if (this.sign_imagesize) {
                            const maxSizeBytes = this.sign_imagesize * 1024 * 1024; 
                            if (selectedFile.size > maxSizeBytes) {
                                this.showSnackbar("#b71c1c", `Signature file size must be less than or equal to ${this.sign_imagesize} MB`);
                                this.signature_image = null; 
                                this.sigFile = null;
                                return;
                            }
                        }

                        this.isvaliddimantions = true;
                        this.cropImageSrc = e.target.result;
                        this.cropDialog = true;
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(selectedFile);
            },

            handleFileChange() {
                const selectedFile = this.file
                if (!selectedFile){
                    return
                }

                this.currentCropType = 'document';
                this.originalFile = selectedFile
                const reader = new FileReader()

                reader.onload = (e) => {
                    const img = new Image()

                    img.onload = () => {
                        this.fileHeight = img.height
                        this.fileWidth = img.width
                        if (this.isdimentionrequired) {
                            if (
                                this.fileHeight > this.documentheight ||
                                this.fileWidth > this.documentwidth
                            ) {
                                alert("Height And Width Not Matching..")
                                this.isvaliddimantions = false
                                return
                            }
                        }
                        this.isvaliddimantions = true
                        this.cropImageSrc = e.target.result
                        this.cropDialog = true
                    }
                    img.src = e.target.result
                }
                reader.readAsDataURL(selectedFile)
            },

            getDocumentConfig(item) {
                const data = {
                    document: item
                };
                axios
                    .post("/Icard/getDocumentConfig", data)
                    .then((res) => {
                        this.req_imagetype_doc = res.data.imagetype;
                        this.req_imagetype_size = res.data.documentfilesize;
                        this.documentheight = res.data.documentheight
                        this.documentwidth = res.data.documentwidth,
                            this.isdimentionrequired = res.data.isdimentionrequired
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                        this.show_parent_id = true;
                    });
            },
            getCitiesLocal(state) {
                const data = {
                    state: state,
                };
                axios
                    .post("/admissionForm/getCityList", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.cities_list = res.data.cities_list;
                            this.cities_list = res.data.cities_list;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                            this.cities_list = [];
                            this.cities_list = [];
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            getCitiesPermanant(state) {
                const data = {
                    state: state,
                };
                axios
                    .post("/admissionForm/getCityList", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.cities_list_permanant = res.data.cities_list;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                            this.cities_list_permanant = [];
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            getStates(country) {
                //alert("country::"+country)
                const data = {
                    country: country,
                };
                axios
                    .post("/admissionForm/getStatesList", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.state_list = res.data.state_details;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                            this.state_list = []; //this.cities_list=[]
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            getPrint() {
                let routeData = this.$router.resolve({ name: "student-health-card" });
                window.open(routeData.href, "_blank");
                //   this.getprint = false;
            },
            // call() {
            //   localStorage.setItem("child_div_id", JSON.stringify(this.child_div_id));
            //   let routeData = this.$router.resolve({ name: "student-health-card" });
            //   window.open(routeData.href, "_blank");
            // },
            uploadDocument() {
                if (this.file == null) {
                    this.showSnackbar("#b71c1c", "Please select file");
                    return;
                }
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("ldid", this.learnerDivision_id);
                formData.append("documenttype", this.documenttype);
                formData.append("fileHeight", this.fileHeight);
                formData.append("fileWidth", this.fileWidth);
                this.upload_image_loader = true;
                axios
                    .post("/Admission/saveUploadStudentDocuments", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.showSnackbar("#4caf50", "Document uploaded successfully");
                            this.stud_data = res.data.stud_data;
                        }
                        else if (res.data.status == "NOF") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                            this.stud_data = res.data.stud_data;
                        } else if (res.data.status == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                            this.file = null;
                        }
                        else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.upload_image_loader = false;
                    })
                    .catch((error) => {
                        // alert("in else catch");
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.upload_image_loader = false;
                    })
                    .finally(() => {
                        this.upload_image_loader = false;
                        this.file = null;
                    });
            },
            uploadCasteCertificate() {
                if (this.cast_cert == null) {
                    this.showSnackbar("#b71c1c", "Please select file");
                    return;
                }
                let formData = new FormData();
                formData.append("file", this.cast_cert);
                formData.append("ldid", this.learnerDivision_id);
                this.upload_image_loader = true;
                axios
                    .post("/Admission/saveUploadCasteCertificate", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.showSnackbar("#4caf50", "Document uploaded successfully");
                            this.stud_data = res.data.stud_data;
                        }
                        else if (res.data.status == "NOF") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                            this.stud_data = res.data.stud_data;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.upload_image_loader = false;
                    })
                    .catch((error) => {
                        //  alert("in else catch");
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.upload_image_loader = false;
                    })
                    .finally(() => {
                        this.upload_image_loader = false;
                        this.cast_cert = null;
                    });
            },
            // downloadImage(url) {
            //   fetch(url)
            //     .then((resp) => resp.blob())
            //     .then((blobobject) => {
            //       const blob = window.URL.createObjectURL(blobobject);
            //       const anchor = document.createElement("a");
            //       anchor.style.display = "none";
            //       anchor.href = blob;
            //       anchor.download = "name.png";
            //       document.body.appendChild(anchor);
            //       anchor.click();
            //       window.URL.revokeObjectURL(blob);
            //     })
            //     .catch(() => console.log("An error in downloading the file sorry"));
            // },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            downloadImg(url) {
                // let url = this.remoteURL();
                let prn = this.stud_data.registration_number;
                if (prn == null) {
                    prn = "stud";
                }
                prn += ".jpg";
                fetch(url)
                    .then((response) => response.blob())
                    .then((blob) => {
                        saveAs(blob, prn);
                    })
                    .catch((err) => {
                        alert(err);
                    });
                console.log("downloading", url);
            },
            uploadHealthDetails() {
                if (this.health_card == null) {
                    this.showSnackbar("#b71c1c", "Please select file");
                    return;
                }
                if (this.documentname == null) {
                    this.showSnackbar("#b71c1c", "Please Enter Document Name");
                    return;
                }
                let formData = new FormData();
                for (var i = 0; i < this.health_card.length; i++) {
                    let file = this.health_card[i];
                    formData.append("files", file);
                }
                //  formData.append("files", this.health_card);
                formData.append("ldid", this.learnerDivision_id);
                formData.append("documentname", this.documentname);
                this.upload_image_loader = true;
                axios
                    .post("/parent/saveChildHealthDetails", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Health check-up report uploaded successfully");
                            this.health_card_details = res.data.health_cards_old;
                            this.getData();
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.upload_image_loader = false;
                    })
                    .catch((error) => {
                        // alert("in else catch");
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.upload_image_loader = false;
                    })
                    .finally(() => {
                        this.upload_image_loader = false;
                        this.health_card = null;
                        this.documentname = "";
                    });
            },
            uploadImage() {
                if (this.profile_image == null) {
                    this.image_msg = "Please select image";
                    return;
                }
                // let file1 = this.profile_image;
                // let file_size = file1.size;
                // if (file_size >= this.imagesize) {
                //     var size = this.imagesize / 1000000
                //     this.image_msg = "Upload Image less than "+ size +"MB";
                //     this.profile_image = null;
                //     return;
                // } else {
                //     this.image_msg = null;
                // }
                let formData = new FormData();
                formData.append("files", this.profile_image);
                formData.append("ldid", this.learnerDivision_id);
                formData.append("registration_number", this.stud_data.registration_number);
                formData.append("fileHeight", this.fileHeight);
                formData.append("fileWidth", this.fileWidth);

                this.upload_image_loader = true;
                axios
                    .post("/parent/saveChildPhoto", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("success", res.data.snackbar);
                            this.photo_path = res.data.photo_path;
                        } else if (res.data.status == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                            this.profile_image = null;
                        }
                        else {
                            this.showSnackbar("error", res.data.snackbar);
                        }
                        this.upload_image_loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.upload_image_loader = false;
                    })
                    .finally(() => {
                        this.upload_image_loader = false;
                    });
            },
            uploadSignature() {
                if (this.signature_image == null) {
                    this.signature_msg = "Please select signature image";
                    return;
                }
                let formData = new FormData();
                formData.append("files", this.signature_image);
                formData.append("ldid", this.learnerDivision_id);
                formData.append("registration_number", this.stud_data.registration_number);
                formData.append("fileHeight", this.sign_fileHeight);
                formData.append("fileWidth", this.sign_fileWidth);
                this.signature_loader = true;

                axios
                    .post("/parent/saveChildSignature", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", res.data.snackbar);
                            this.signature_path = res.data.signature_photo_path; 
                            this.signature_image = null; 
                            this.sigFile = null;
                        } 
                        else if (res.data.status == "NO" || res.data.flag == "NO") {
                            let errorMsg = res.data.fmsg ? res.data.fmsg : res.data.snackbar;
                            this.showSnackbar("#b71c1c", errorMsg);
                            this.signature_image = null; 
                            this.sigFile = null;
                        } 
                        else {
                            this.showSnackbar("#b71c1c", res.data.snackbar || "Upload failed.");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.signature_loader = false;
                    });
            },

            validateImage() {
                if (this.profile_image == null) return;

                let file1 = this.profile_image;
                let file_size = file1.size;
                console.log("file_size", file_size);
                console.log("width", this.profile_image.width);
                console.log("height", file1.naturalHeight);

                let file_name = this.profile_image.name;
                let ext = file_name.split(".").pop();
                if (file_size >= 1000000) {
                    this.image_msg = "Upload Image less than 1MB";
                    this.profile_image = null;
                    return;
                } else {
                    this.image_msg = null;
                }
                console.log("ext", this.allowed_extensions.includes(ext));
                if (!this.allowed_extensions.includes(ext)) {
                    this.image_msg = "Please upload only jpg/jpeg file";
                    this.profile_image = null;
                    return;
                }
            },
            getData() {
                const formData = {
                    lid: this.lid,
                };
                axios
                    .post("/admission/getStudData", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.stud_data = res.data.stud_data;
                            this.stud_data.category_list.unshift("NA");
                            this.stud_data.quota_list.unshift("NA");
                            // this.stud_data.religion_list.unshift("NA");
                            this.stud_data.domacile_list.unshift("NA");
                            // this.stud_data.cast_list.unshift("NA");
                            // this.stud_data.ay_list.unshift('NA')
                            this.stud_data.ay = this.stud_data.admissionyear_id;
                            this.formatted_dob = res.data.stud_data.formatted_dob;
                            // alert(this.stud_data.stud_date_of_birth)
                            // if (!this.formatted_dob) {
                            //     let formatDate = moment(this.stud_data.stud_date_of_birth).format("MMMM Do YYYY");
                            //     this.stud_data.stud_date_of_birth_in_words = formatDate;
                            // }
                            this.critical_edit = res.data.critical_edit;
                            this.edit_student_quota_admission_year = res.data.edit_student_quota_admission_year;
                            this.edit_student_gr_no_prefix = res.data.edit_student_gr_no_prefix;
                            this.photo_path = res.data.photo_path;
                            this.learnerDivision_id = res.data.learnerDivision_id;
                            this.child_div_id = res.data.learnerDivision_id;
                            localStorage.setItem("child_div_id", JSON.stringify(this.child_div_id));
                            // alert(this.child_div_id);
                            this.health_card_details = res.data.health_card;
                            this.document_type_list = res.data.document_type_list;
                            this.family_type_list = res.data.family_type_list;
                            this.country_list = res.data.country_list;
                            this.state_list = res.data.states_list;
                            this.cities_list = res.data.cities_list;
                            this.academicyear_list = res.data.academicyear_list;
                            this.cities_list_permanant = res.data.cities_list;
                            this.district_list = res.data.district_list;
                            this.sibling1 = res.data.sibling1
                            this.sibling2 = res.data.sibling2
                            this.standard_list = res.data.standard_list
                            this.language_list = res.data.language_list
                            // this.imagesize = res.data.imagesize;
                            // this.imagetype = res.data.imagetype;
                            this.imagesize = res.data.imagesize;
                            this.imagetype = res.data.imagetype;
                            this.isdimentionrequired = res.data.isdimentionrequired;
                            this.documentheight = res.data.height,
                                this.documentwidth = res.data.width
                            this.show_quota = res.data.show_quota
                            this.show_ay = res.data.show_ay
                            this.signRequires = res.data.signRequires;
                            this.sign_imagetype = res.data.sign_imagetype;
                            this.sign_imagesize = res.data.sign_imagesize;
                            this.sign_isdimentionrequired = res.data.sign_isdimentionrequired;
                            this.sign_height = res.data.sign_height;
                            this.sign_width = res.data.sign_width;
                            this.signature_path = res.data.signature_photo_path;
                            this.disabled_gr_number = res.data.disabled_gr_number;
                            //  alert("res.data.learnerDivision_id"+res.data.learnerDivision_id)
                            //alert("this.learnerDivision_id"+this.learnerDivision_id)
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            saveBasic() {
                if (this.tenant === 'zeal' && this.edit_student_gr_no_prefix) {
                    if (this.stud_data.gr_no && this.stud_data.gr_no.startsWith('0')) {
                        this.showSnackbar("error", "GR Number cannot start with 0");
                        return;
                    }
                }
                // if (this.stud_data.apaar_id && this.stud_data.apaar_id.toString().length !== 12) {
                //     this.showSnackbar("error", "APAAR ID must be exactly 12 digits");
                //     return;
                // }
                // if (this.stud_data.stud_aadhar_no && this.stud_data.stud_aadhar_no.toString().length !== 12) {
                //     this.showSnackbar("error", "Aadhar No. must be exactly 12 digits");
                //     return;
                // }
                // if (this.stud_data.pen_no && this.stud_data.pen_no.toString().length !== 11) {
                //     this.showSnackbar("error", "PEN must be exactly 11 digits");
                //     return;
                // }
                var form = document.getElementById("student_data");
                var formData = new FormData(form);
                formData.append("registration_number", this.stud_data.registration_number);
                if (!this.formatted_dob) {
                    formData.append("stud_date_of_birth", this.stud_data.stud_date_of_birth);
                }

                formData.append("languages_known", this.stud_data.languages_known);
                formData.append("standard", this.stud_data.standard);
                formData.append("division", this.stud_data.division);           
                formData.append("isvaccination", this.stud_data.isvaccination);
                formData.append("issingleparent", this.stud_data.issingleparent);
                this.save_loader = true;
                axios.post("/Admission/saveStudData", formData).then(
                    (response) => {
                        if (response.data.status == "basic_save") {
                            this.showSnackbar("#4caf50", "Basic updated successfully...!"); // show snackbar on success
                        } else {
                            this.showSnackbar("error", response.data.status); // show snackbar on success
                        }
                        this.save_loader = false;
                    },
                    (response) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on failure
                        this.save_loader = false;
                        // error callback
                    }
                );
            },
            saveOther() {
                var form = document.getElementById("student_data");
                var formData = new FormData(form);
                formData.append("registration_number", this.stud_data.registration_number);
                formData.append("admission_date", this.stud_data.admission_date);
                formData.append("physical_date", this.stud_data.physical_date);
                formData.append("admission_year", this.stud_data.admissionyear_id);
                formData.append("house_id", this.stud_data.house_id);
                formData.append("transportaion_mode", this.stud_data.transportaion_mode);
                formData.append("currentstandard_id", this.stud_data.currentstandard_id);
                formData.append("admittedstandard_id", this.stud_data.admittedstandard_id);
                formData.append("is_admitted_for_term_1", this.stud_data.is_admitted_for_term_1);
                formData.append("previousschoolpassingstandard_id", this.stud_data.previousschoolpassingstandard_id);
                formData.append("school_medium", this.stud_data.school_medium);
                this.save_loader = true
                axios.post("/Admission/saveStudData", formData).then(
                    (response) => {
                        if (response.data.status == "other_save") {
                            this.showSnackbar("#4caf50", "Updated successfully...!"); // show snackbar on success
                            this.save_loader = false
                        } else {
                            this.showSnackbar("red", "Changing admission year may change your fee structure!"); // show snackbar on success
                            this.save_loader = false
                        }
                    },
                    (response) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on failure
                        // error callback
                        this.save_loader = false
                    }
                );
            },
            saveDriverInfo() {
                var form = document.getElementById("student_data");
                var formData = new FormData(form);
                formData.append("registration_number", this.stud_data.registration_number);
                formData.append("admission_date", this.stud_data.admission_date);
                formData.append("physical_date", this.stud_data.physical_date);
                formData.append("admission_year", this.stud_data.admissionyear_id);
                formData.append("house_id", this.stud_data.house_id);
                formData.append("transportaion_mode", this.stud_data.transportaion_mode);
                formData.append("currentstandard_id", this.stud_data.currentstandard_id);
                formData.append("admittedstandard_id", this.stud_data.admittedstandard_id);
                formData.append("is_admitted_for_term_1", this.stud_data.is_admitted_for_term_1);
                formData.append("previousschoolpassingstandard_id", this.stud_data.previousschoolpassingstandard_id);
                console.log(formData);
                this.save_loader = true;
                axios.post("/Admission/saveStudData", formData).then(
                    (response) => {
                        if (response.data.status == "other_save") {
                            this.showSnackbar("#4caf50", "Other  Details updated successfully...!"); // show snackbar on success
                        }
                        this.save_loader = false;
                    },
                    (response) => {
                        // error callback
                        this.save_loader = false;
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on failure
                    }
                );
            },
            saveHealthInfo() {
                var form = document.getElementById("student_data");
                var formData = new FormData(form);
                formData.append("registration_number", this.stud_data.registration_number);
                console.log(formData);
                this.save_loader = true;
                axios.post("/Admission/saveStudData", formData).then(
                    (response) => {
                        if (response.data.status == "health_save") {
                            this.showSnackbar("#4caf50", "Health Details updated successfully...!"); // show snackbar on success
                        }
                        this.save_loader = false;
                    },
                    (response) => {
                        // error callback
                        this.save_loader = false;
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on failure
                    }
                );
            },
            saveContact() {
                if(this.stud_data.contact_number){
                    if(this.stud_data.contact_number.length<10 || this.stud_data.contact_number.length > 10){
                        this.showSnackbar("#b71c1c", "Enter 10 Digit Contact Number");
                        return
                    }
                }
                if(this.stud_data.father_contact_number){
                    if(this.stud_data.father_contact_number.length<10 || this.stud_data.father_contact_number.length > 10){
                        this.showSnackbar("#b71c1c", "Enter 10 Digit Father Contact Number");
                        return
                    }
                }
                if(this.stud_data.student_contact_number){
                    if(this.stud_data.student_contact_number.length<10 || this.stud_data.student_contact_number.length > 10){
                        this.showSnackbar("#b71c1c", "Enter 10 Digit Student Contact Number");
                        return
                    }
                }
            
                if(this.stud_data.mother_contact_number){
                    if(this.stud_data.mother_contact_number.length<10 || this.stud_data.mother_contact_number.length > 10){
                        this.showSnackbar("#b71c1c", "Enter 10 Digit Mother Contact Number");
                        return
                    }
                }
                if(this.stud_data.stud_emergency_contact_number){
                    if(this.stud_data.stud_emergency_contact_number.length<10 || this.stud_data.stud_emergency_contact_number.length > 10){
                        this.showSnackbar("#b71c1c", "Enter 10 Digit Emergency Contact Number");
                        return
                    }
                }
                var form = document.getElementById("student_data");
                var formData = new FormData(form);
                formData.append("registration_number", this.stud_data.registration_number);
                console.log(formData);
                this.save_loader = true;
                axios.post("/Admission/saveStudData", formData).then(
                    (response) => {
                        if (response.data.status == "contact_save") {
                            this.showSnackbar("#4caf50", "Contact Details updated successfully...!"); // show snackbar on success
                        }
                        this.save_loader = false;
                    },
                    (response) => {
                        // error callback
                        this.save_loader = false;
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on failure
                    }
                );
            },
            saveAddress() {
                var form = document.getElementById("student_data");
                var formData = new FormData(form);
                formData.append("registration_number", this.stud_data.registration_number);
                console.log(formData);
                axios.post("/Admission/saveStudData", formData).then(
                    (response) => {
                        if (response.data.status == "address_save") {
                            this.showSnackbar("#4caf50", "Address Details updated successfully...!"); // show snackbar on success
                        }
                    },
                    (response) => {
                        // error callback
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on failure
                    }
                );
            },
            saveRelative() {
                var form = document.getElementById("student_data");
                var formData = new FormData(form);
                formData.append("registration_number", this.stud_data.registration_number);
                console.log(formData);
                axios.post("/Admission/saveStudData", formData).then(
                    (response) => {
                        if (response.data.status == "relative_save") {
                            this.showSnackbar("#4caf50", "Details updated successfully...!"); // show snackbar on success
                        }
                    },
                    (response) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on failure
                        // error callback
                    }
                );
            },
            saveCastInfo() {
                var form = document.getElementById("student_data");
                var formData = new FormData(form);
                formData.append("registration_number", this.stud_data.registration_number);
                console.log(formData);
                axios.post("/Admission/saveStudData", formData).then(
                    (response) => {
                        if (response.data.status == "cast_save") {
                            this.showSnackbar("#4caf50", "Cast information updated successfully...!"); // show snackbar on success
                        } else {
                            this.showSnackbar("red", "Can`t change quota,student reciept generated...!");
                        }
                    },
                    (response) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on failure
                        // error callback
                    }
                );
            },
            copyAddress() {
                if (this.pladdress) {
                    // alert("in checkbox");

                    this.stud_data.ppin = this.stud_data.lpin;
                    this.stud_data.pcountry = this.stud_data.lcountry;
                    this.stud_data.paddress = this.stud_data.laddress;
                    this.stud_data.pcity = this.stud_data.lcity;
                    this.stud_data.pstate = this.stud_data.lstate;
                    this.stud_data.pdistrict = this.stud_data.ldistrict;
                    this.stud_data.ptaluka = this.stud_data.ltaluka;
                    this.stud_data.unicode_paddress = this.stud_data.unicode_laddress;
                }
            },
            copyFullName() {
                if (this.StudFullName) {
                    // alert("in checkbox");
                    this.stud_data.stud_fullname = this.stud_data.stud_firstname + " " + " " + this.stud_data.stud_middlename + " " + this.stud_data.stud_lastname;
                    // ${stud_data.stud_firstname} ${stud_data.stud_middlename} ${stud_data.stud_lastname}
                }
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            deleteAttachment(item) {
                if (!confirm("Are you sure you want to delete this document?")) return;
                this.delete_load = true;
                const data = {
                    learner_id: this.stud_data.lid,
                    doc_id: item.doc_id,
                };
                console.log("957 data");
                console.log(data);
                axios
                    .post("/Admission/deleteDocument", data)
                    .then((res) => {
                        this.delete_load = false;
                        if (res.data.status == "YES") {
                            this.showSnackbar("#4caf50", "Document deleted successfully..."); // show snackbar on success
                            this.getData();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar
                            //alert(res.data.status_reason)
                        }
                    })
                    .catch((error) => {
                        this.delete_load = false;
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.delete_load = false;
                    });
            },
            
              deleteDocument(item,index) {
                alert("Are you sure want to delete this document")
                {
                    const data = {
                       id : item.id
                    }
                  this.health_card_details.splice(index, 1);

                    axios.post("/Admission/deleteHealthDocument", data)
                    .then(res => {
                        if (res.data.flag === "YES") {
                            this.showSnackbar("#4caf50", "Document Deleted successfully...!");
                            this.dialog = false;
                        } else {
                            alert("Something went wrong!");
                            this.dialog = false;
                        }
                    })
                    .catch(error => {
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.stop();
                    });
                }
            },
        },
    };
</script>
<style scoped>
    .active {
        color: #222222;
        background-color: #ffff;
    }

    #camera {
        text-align: center;
        color: #2c3e50;
    }

    #video {
        background-color: #000000;
    }

    #canvas {
        display: none;
    }

    li {
        display: inline;
        padding: 5px;
    }
    .crop-box {
  position: absolute;
}

.resize {
  position: absolute;
  background: transparent;
}

.resize.top {
  top: -5px;
  left: 0;
  width: 100%;
  height: 10px;
  cursor: ns-resize;
}

.resize.bottom {
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 10px;
  cursor: ns-resize;
}

.resize.left {
  left: -5px;
  top: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;
}

.resize.right {
  right: -5px;
  top: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;
}

/* .corner {
  position: absolute;
  width: 10px;
  height: 10px;
  background: red;
  z-index: 10;
} */

/* Corner positions */
.corner {
  position: absolute;
  width: 20px;
  /* total clickable area */
  height: 20px;
  z-index: 10;
}

.crop-box {
  position: absolute;
  border: 2px dotted red;
  /* main dotted border */
  box-sizing: border-box;
}

.crop-box .corner {
  position: absolute;
  width: 20px;
  height: 20px;
  z-index: 10;
}

.crop-box .corner span {
  position: absolute;
  background-color: red;
}

.crop-box .corner .hor {
  height: 3px;
  width: 14px;
}

.crop-box .corner .ver {
  width: 3px;
  height: 14px;
}

.crop-box .corner.top-left .hor {
  top: 0;
  left: 0;
}

.crop-box .corner.top-left .ver {
  top: 0;
  left: 0;
}

.crop-box .corner.top-right .hor {
  top: 0;
  right: 0;
}

.crop-box .corner.top-right .ver {
  top: 0;
  right: 0;
}

.crop-box .corner.bottom-left .hor {
  bottom: 0;
  left: 0;
}

.crop-box .corner.bottom-left .ver {
  bottom: 0;
  left: 0;
}

.crop-box .corner.bottom-right .hor {
  bottom: 0;
  right: 0;
}

.crop-box .corner.bottom-right .ver {
  bottom: 0;
  right: 0;
}

.crop-box .corner.top-left {
  top: -4px;
  left: -4px;
  cursor: nwse-resize;
}

.crop-box .corner.top-right {
  top: -4px;
  right: -4px;
  cursor: nesw-resize;
}

.crop-box .corner.bottom-left {
  bottom: -4px;
  left: -4px;
  cursor: nesw-resize;
}

.crop-box .corner.bottom-right {
  bottom: -4px;
  right: -4px;
  cursor: nwse-resize;
}
.crop-box {
  position: absolute;
  z-index: 5;
}

.v-card-actions {
  position: relative;
  z-index: 20;
}
</style>